/**
 * Published KMahjongg layout grids.
 *
 * Source: KDE KMahjongg `layouts/` directory, vendored into this repository.
 * Upstream project: KDE KMahjongg.
 * Format: kmahjongg-layout-v1.0 / v1.1.
 * License: KDE KMahjongg repository includes GPL-2.0-or-later license text.
 *
 * This file is generated from upstream layout data. Do not hand-edit grids.
 */

export interface KMahjonggLayoutSource {
  id: string;
  name: string;
  sourceFile: string;
  raw: string;
}

export const KMAHJONGG_LAYOUT_SOURCES: readonly KMahjonggLayoutSource[] = [
  {
    id: "turtle",
    name: "The Turtle",
    sourceFile: "default.layout",
    raw: String.raw`
kmahjongg-layout-v1.1
# Board size in quarter tiles
w32
h16
# Board depth
d5
# Level 0 -------------------------
...121212121212121212121212.....
...434343434343434343434343.....
.......1212121212121212.........
.......4343434343434343.........
.....12121212121212121212.......
.....43434343434343434343.......
...121212121212121212121212.....
.124343434343434343434343431212.
.431212121212121212121212124343.
...434343434343434343434343.....
.....12121212121212121212.......
.....43434343434343434343.......
.......1212121212121212.........
.......4343434343434343.........
...121212121212121212121212.....
...434343434343434343434343.....
# Level 1 -------------------------
................................
................................
.........121212121212...........
.........434343434343...........
.........121212121212...........
.........434343434343...........
.........121212121212...........
.........434343434343...........
.........121212121212...........
.........434343434343...........
.........121212121212...........
.........434343434343...........
.........121212121212...........
.........434343434343...........
................................
................................
# Level 2 -------------------------
................................
................................
................................
................................
...........12121212.............
...........43434343.............
...........12121212.............
...........43434343.............
...........12121212.............
...........43434343.............
...........12121212.............
...........43434343.............
................................
................................
................................
................................
# Level 3 -------------------------
................................
................................
................................
................................
................................
................................
.............1212...............
.............4343...............
.............1212...............
.............4343...............
................................
................................
................................
................................
................................
................................
# Level 4 -------------------------
................................
................................
................................
................................
................................
................................
................................
..............12................
..............43................
................................
................................
................................
................................
................................
................................
................................
`,
  },
  {
    id: "dragon",
    name: "Dragon",
    sourceFile: "dragon.layout",
    raw: String.raw`
kmahjongg-layout-v1.1
# Board size in quarter tiles
w32
h16
# Board depth
d4
# Level 0 -------------------------
...121212..............121212...
.1243434312..........1243434312.
.43......43121212121243......43.
.12..12....4343434343...12...12.
.43..43....12......12...43...43.
.12........43......43........12.
.431212121212..12..121212121243.
...4343434343..43..4343434343...
.......12..12......12..12.......
.......43..43......43..43.......
.....1212121212121212121212.....
.....4343434343434343434343.....
.....12..................12.....
.....43..12..12..12..12..43.....
.....1212431243124312431212.....
.....4343..43..43..43..4343.....
# Level 1 -------------------------
...121212..............121212...
.1243434312..........1243434312.
.43......43..121212..43......43.
.12..12......434343.....12...12.
.43..43....12......12...43...43.
.12........43......43........12.
.43121212..12..12..12..12121243.
...434343..43..43..43..434343...
.......12..12......12..12.......
.......43..43......43..43.......
.....12....1212121212....12.....
.....43....4343434343....43.....
.....12..................12.....
.....43..12..12..12..12..43.....
.....12..43..43..43..43..12.....
.....43..................43.....
# Level 2 -------------------------
.....12..................12.....
.....43..12..........12..43.....
.........43....12....43.........
.12............43............12.
.43..........................43.
................................
.....12..................12.....
.....43..................43.....
................................
................................
.....12..................12.....
.....43..................43.....
.....12..................12.....
.....43..12..12..12..12..43.....
.....12..43..43..43..43..12.....
.....43..................43.....
# Level 3 -------------------------
.....12..................12.....
.....43..................43.....
................................
.12..........................12.
.43..........................43.
................................
.....12..................12.....
.....43..................43.....
................................
................................
.....12..................12.....
.....43..................43.....
.....12..................12.....
.....43..12..12..12..12..43.....
.........43..43..43..43.........
................................
`,
  },
  {
    id: "cat",
    name: "Cat",
    sourceFile: "cat.layout",
    raw: String.raw`
kmahjongg-layout-v1.1
# Board size in quarter tiles
w36
h16
# Board depth
d4
# Level 0 -------------------------
............................12......
............................4312....
..............................4312..
................................43..
................12121212121212....12
..............1243434343434343....43
..12121212....431212121212121212..12
..43434343..12124343434343434343..43
1212121212..4343121212121212121212..
4343434343..1212434343434343434343..
1212121212..4343121212121212121212..
4343434343..1212434343434343434343..
1212121212..4343121212121212121212..
434343434312..12434343434343434343..
..1212121243..431212121212121212....
..43434343......4343434343434343....
# Level 1 -------------------------
............................12......
............................4312....
..............................4312..
................................43..
....................................
....................................
..................121212121212......
..................434343434343......
....1212........1212121212121212....
....4343......124343434343434343....
..12121212....431212121212121212....
..43434343......4343434343434343....
....1212..........121212121212......
....4343..........434343434343......
....................................
....................................
# Level 2 -------------------------
....................................
....................................
....................................
....................................
....................................
....................................
....................................
....................................
..................1212121212........
....1212..........4343434343........
....4343..........1212121212........
....1212..........4343434343........
....4343............................
....................................
....................................
....................................
# Level 3 -------------------------
....................................
....................................
....................................
....................................
....................................
....................................
....................................
....................................
....................................
....................121212..........
....................434343..........
....................................
....................................
....................................
....................................
....................................
`,
  },
  {
    id: "crab",
    name: "Crab",
    sourceFile: "crab.layout",
    raw: String.raw`
kmahjongg-layout-v1.1
# Board size in quarter tiles
w32
h16
# Board depth
d4
# Level 0 -------------------------
...12121212..........12121212...
...43434343..........43434343...
...12121212...1212...12121212...
...43434343...4343...43434343...
.......121212121212121212.......
.......434343434343434343.......
..1212.....1212121212.....1212..
..4343.....4343434343.....4343..
..12......121212121212......12..
..43......434343434343......43..
......12121212121212121212......
......43434343434343434343......
..12121212..12121212..12121212..
..43434343..43434343..43434343..
..12121212...121212...12121212..
..43434343...434343...43434343..
# Level 1 -------------------------
.....121212..........121212.....
.....434343..........434343.....
.....121212...1212...121212.....
.....434343...4343...434343.....
.........12..........12.........
.........43..........43.........
..1212.......121212.......1212..
..4343.......434343.......4343..
..12........12121212........12..
..43........43434343........43..
..........121212121212..........
..........434343434343..........
....121212............121212....
....434343............434343....
....121212...121212...121212....
....434343...434343...434343....
# Level 2 -------------------------
................................
......1212............1212......
......4343.....12.....4343......
...............32...............
................................
................................
...............12...............
...............43...............
..............1212..............
..............4343..............
..............1212..............
..............4343..............
................................
.....1212..............1212.....
.....4343......12......4343.....
...............43...............
# Level 3 -------------------------
................................
................................
................................
................................
................................
................................
................................
................................
...............12...............
...............43...............
...............12...............
...............43...............
................................
................................
................................
................................
`,
  },
  {
    id: "spider",
    name: "Spider",
    sourceFile: "spider.layout",
    raw: String.raw`
kmahjongg-layout-v1.1
# Board size in quarter tiles
w32
h16
# Board depth
d4
# Level 0 -------------------------
......1212...12..12...1212......
......4343...43..43...4343......
........12....1212....12........
..12....4312..4343..1243....12..
..4312....431212121243....1243..
....431212..43434343..121243....
......43431212121212124343......
..........434343434343..........
.........12121212121212.........
.121212124343434343434312121212.
.43434343.121212121212.43434343.
..........434343434343..........
........12..12121212..12........
......1243..43434343..4312......
..121243......1212......431212..
..4343........4343........4343..
# Level 1 -------------------------
......1212...12..12...1212......
......4343...43..43...4343......
........12............12........
..12....4312........1243....12..
..4312....43..1212..43....1243..
....431212....4343....121243....
......4343..12121212..4343......
............43434343............
...........1212121212...........
.12121212..4343434343..12121212.
.43434343...12121212...43434343.
............43434343............
........12....1212....12........
......1243....4343....4312......
..121243......1212......431212..
..4343........4343........4343..
# Level 2 -------------------------
........12............12........
........43............43........
................................
..12......12........12......12..
..43......43........43......43..
......12................12......
......43......1212......43......
..............4343..............
.............121212.............
.12..12......434343......12..12.
.43..43.......1212.......43..43.
..............4343..............
..............1212..............
......12......4343......12......
..12..43................43..12..
..43........................43..
# Level 3 -------------------------
................................
................................
................................
................................
................................
................................
................................
................................
................................
...............12...............
...............43...............
................................
................................
................................
................................
................................
`,
  },
  {
    id: "castle",
    name: "Castle",
    sourceFile: "castle.layout",
    raw: String.raw`
kmahjongg-layout-v1.1
# Board size in quarter tiles
w32
h16
# Board depth
d4
# Level 0 -------------------------
...12121212..........12121212...
...43434343..........43434343...
...12121212...1212...12121212...
...43434343...4343...43434343...
.......121212121212121212.......
.......434343434343434343.......
..1212.....1212121212.....1212..
..4343.....4343434343.....4343..
..12......121212121212......12..
..43......434343434343......43..
......12121212121212121212......
......43434343434343434343......
..12121212..12121212..12121212..
..43434343..43434343..43434343..
..12121212...121212...12121212..
..43434343...434343...43434343..
# Level 1 -------------------------
.....121212..........121212.....
.....434343..........434343.....
.....121212...1212...121212.....
.....434343...4343...434343.....
.........12..........12.........
.........43..........43.........
..1212.......121212.......1212..
..4343.......434343.......4343..
..12........12121212........12..
..43........43434343........43..
..........121212121212..........
..........434343434343..........
....121212............121212....
....434343............434343....
....121212...121212...121212....
....434343...434343...434343....
# Level 2 -------------------------
................................
......1212............1212......
......4343.....12.....4343......
...............32...............
................................
................................
...............12...............
...............43...............
..............1212..............
..............4343..............
..............1212..............
..............4343..............
................................
.....1212..............1212.....
.....4343......12......4343.....
...............43...............
# Level 3 -------------------------
................................
......1212............1212......
......4343.....12.....4343......
...............32...............
................................
................................
................................
................................
..............1212..............
..............4343..............
..............1212..............
..............4343..............
................................
.....1212..............1212.....
.....4343......12......4343.....
...............43...............
`,
  },
  {
    id: "castle2",
    name: "Castle View",
    sourceFile: "castle2.layout",
    raw: String.raw`
kmahjongg-layout-v1.0
........................1212....
........................4343....
......................12121212..
......................43434343..
....12..12..12..12.12.1212..12..
....43..43..43..43.43.4343..43..
....12121212121212121212121212..
....43434343434343434343434343..
....12121212121212121212121212..
....43434343434343434343434343..
..121212..12121212121212121212..
..434343..43434343434343434343..
12121212121212..12121212121212..
43434343434343..43434343434343..
121212121212......121212....1212
434343434343......434343....4343
.........................12.....
.........................43.....
......................12121212..
......................43434343..
......................12....12..
......................43....43..
....12121212121212121212....12..
....43434343434343434343....43..
....12................12....12..
....43................43....43..
....12........12......12....12..
....43........43......43....43..
....12......12..12....12....12..
....43......43..43....43....43..
....12..1212......121212....12..
....43..4343......434343....43..
.........................12.....
.........................43.....
......................12.12.12..
......................43.43.43..
................................
................................
....12..12..12..12..12..........
....43..43..43..43..43..........
......................12....12..
......................43....43..
....12........12................
....43........43................
............12..12....12....12..
............43..43....43....43..
....12....12......12..12....12..
....43....43......43..43....43..
.........................12.....
.........................43.....
.........................12.....
.........................43.....
................................
................................
................................
................................
................................
................................
..............12................
..............43................
............12..12..............
............43..43..............
......................12....12..
......................43....43..
................................
.........................12.....
.........................43.....
................................
................................
................................
................................
................................
................................
................................
..............12................
..............43................
................................
................................
................................
................................
`,
  },
  {
    id: "4-winds",
    name: "4 Winds",
    sourceFile: "4_winds.layout",
    raw: String.raw`
kmahjongg-layout-v1.0
......12..1212....1212..12......
......43..4343....4343..43......
......12121212121212121212......
......43434343434343434343......
......12..121212121212..12......
......43..434343434343..43......
....121212121212121212121212....
..1243434343434343434343434312..
..4312121212121212121212121243..
....434343434343434343434343....
......12..121212121212..12......
......43..434343434343..43......
......12121212121212121212......
......43434343434343434343......
......12..1212....1212..12......
......43..4343....4343..43......
......12..12........12..12......
......43..43........43..43......
......121212........121212......
......434343........434343......
......12..121212121212..12......
......43..434343434343..43......
......121212........121212......
....12434343..1212..43434312....
....43121212..4343..12121243....
......434343........434343......
......12..121212121212..12......
......43..434343434343..43......
......121212........121212......
......434343........434343......
......12..12........12..12......
......43..43........43..43......
................................
................................
................................
................................
................................
................................
................................
...............12...............
...............43...............
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
...............12...............
...............43...............
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
`,
  },
  {
    id: "alien",
    name: "Alien",
    sourceFile: "alien.layout",
    raw: String.raw`
kmahjongg-layout-v1.0
..........121212121212..........
..........434343434343..........
..1212121212121212121212121212..
..4343434343434343434343434343..
..12.....12121212121212.....12..
..43.....43434343434343.....43..
..12.......1212121212.......12..
..43.......4343434343.......43..
...........1212121212...........
...........4343434343...........
.............121212.............
.............434343.............
.............12..12.............
.............43..43.............
.12121212121212..12121212121212.
.43434343434343..43434343434343.
...........1212121212...........
...........4343434343...........
..121212...1212121212...121212..
..434343...4343434343...434343..
..12..........1212..........12..
..43..........4343..........43..
..12..........1212..........12..
..43..........4343..........43..
..............1212..............
..............4343..............
...............12...............
...............43...............
................................
................................
.121212121212......121212121212.
.434343434343......434343434343.
............12121212............
............43434343............
..1212......12121212......1212..
..4343......43434343......4343..
..12...........12...........12..
..43...........43...........43..
...............12...............
...............43...............
...............12...............
...............43...............
................................
................................
................................
................................
.1212121212..........1212121212.
.4343434343..........4343434343.
.............121212.............
.............434343.............
..12........12....12........12..
..43........43....43........43..
...............12...............
...............43...............
...............12...............
...............43...............
................................
................................
................................
................................
................................
................................
.12121212..............12121212.
.43434343..............43434343.
..............1212..............
..............4343..............
............12....12............
............43....43............
...............12...............
...............43...............
................................
................................
................................
................................
................................
................................
................................
................................
...1212..................1212...
...4343..................4343...
`,
  },
  {
    id: "altar",
    name: "Altar",
    sourceFile: "altar.layout",
    raw: String.raw`
kmahjongg-layout-v1.0
1212....1212121212121212....1212
4343....4343434343434343....4343
1212....1212121212121212....1212
4343....4343434343434343....4343
........1212121212121212........
........4343434343434343........
........1212121212121212........
........4343434343434343........
........1212121212121212........
........4343434343434343........
..............1212..............
..............4343..............
1212..........1212..........1212
4343..........4343..........4343
1212..........1212..........1212
4343..........4343..........4343
................................
1212........................1212
4343......121212121212......4343
..........434343434343..........
..........121212121212..........
..........434343434343..........
..........121212121212..........
..........434343434343..........
...............12...............
...............43...............
...............12...............
...............43...............
...............12...............
1212...........43...........1212
4343...........12...........4343
...............43...............
................................
.12..........................12.
.43.......121212121212.......43.
..........434343434343..........
..........121212121212..........
..........434343434343..........
..........121212121212..........
..........434343434343..........
...............12...............
...............43...............
...............12...............
...............43...............
...............12...............
.12............43............12.
.43..........................43.
................................
................................
................................
...........1212121212...........
...........4343434343...........
...........1212121212...........
...........4343434343...........
...........1212121212...........
...........4343434343...........
...............12...............
...............43...............
...............12...............
...............43...............
................................
................................
................................
................................
................................
................................
..............1212..............
..............4343..............
............12121212............
............43434343............
.............121212.............
.............434343.............
...............12...............
...............43...............
................................
................................
................................
................................
................................
................................
`,
  },
  {
    id: "arena",
    name: "Arena",
    sourceFile: "arena.layout",
    raw: String.raw`
kmahjongg-layout-v1.0
................................
..1212121212121212121212121212..
..4343434343434343434343434343..
..12121212............12121212..
..43434343............43434343..
..121212................121212..
..434343................434343..
..121212................121212..
..434343................434343..
..121212................121212..
..434343................434343..
..12121212............12121212..
..43434343............43434343..
..1212121212........1212121212..
..4343434343........4343434343..
................................
................................
..12121212............12121212..
..43434343............43434343..
..121212................121212..
..434343................434343..
..1212....................1212..
..4343....................4343..
..1212....................1212..
..4343....................4343..
..1212....................1212..
..4343....................4343..
..121212................121212..
..434343................434343..
..12121212............12121212..
..43434343............43434343..
................................
................................
..1212....................1212..
..4343....................4343..
..1212....................1212..
..4343....................4343..
..1212....................1212..
..4343....................4343..
..1212....................1212..
..4343....................4343..
..1212....................1212..
..4343....................4343..
..1212....................1212..
..4343....................4343..
..1212....................1212..
..4343....................4343..
................................
................................
..1212....................1212..
..4343....................4343..
..12........................12..
..43........................43..
..12........................12..
..43........................43..
..12........................12..
..43........................43..
..12........................12..
..43........................43..
..12........................12..
..43........................43..
..1212....................1212..
..4343....................4343..
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
`,
  },
  {
    id: "arrow",
    name: "Arrow",
    sourceFile: "arrow.layout",
    raw: String.raw`
kmahjongg-layout-v1.0
................................
.12.............................
.43..............12.............
.1212............4312...........
.4343............124312.........
.121212121212121243124312.......
.43434343434343431243124312.....
.121212121212121243124312431212.
.434343434343434312431243124343.
.12121212121212124312431243.....
.434343434343434312431243.......
.1212............431243.........
.4343............1243...........
.12..............43.............
.43.............................
................................
................................
................................
................................
..12............................
..43..............12............
..12121212121212124312..........
..4343434343434343124312........
..121212121212121243124312......
..434343434343434312431243......
..1212121212121212431243........
..43434343434343431243..........
..12..............43............
..43............................
................................
................................
................................
................................
................................
................................
................................
................................
...1212121212121212.............
...434343434343434312...........
...12121212121212124312.........
...43434343434343431243.........
...121212121212121243...........
...4343434343434343.............
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
......121212121212..............
......434343434343..............
......12121212121212............
......43434343434343............
......121212121212..............
......434343434343..............
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
...........121212...............
...........434343...............
...........12121212.............
...........43434343.............
...........121212...............
...........434343...............
................................
................................
................................
................................
................................
`,
  },
  {
    id: "atlantis",
    name: "Atlantis",
    sourceFile: "atlantis.layout",
    raw: String.raw`
kmahjongg-layout-v1.0
12............................12
43............................43
1212........................1212
4343........................4343
1212........................1212
43431212121212121212121212124343
12124343434343434343434343431212
434312......12121212......124343
121243......43434343......431212
43431212121212121212121212124343
12124343434343434343434343431212
4343........................4343
1212........................1212
4343........................4343
12............................12
43............................43
................................
................................
1212........................1212
4343........................4343
12............................12
43....12121212121212121212....43
1212..43434343434343434343..1212
4343..........1212..........4343
1212..........4343..........1212
4343..12121212121212121212..4343
12....43434343434343434343....12
43............................43
1212........................1212
4343........................4343
................................
................................
................................
................................
................................
12............................12
43............................43
12......121212....121212......12
43......434343....434343......43
..12...........12...........12..
..43...........43...........43..
12......121212....121212......12
43......434343....434343......43
12............................12
43............................43
................................
................................
................................
................................
................................
................................
................................
12............................12
43........12........12........43
..........43........43..........
...............12...............
...............43...............
..........12........12..........
12........43........43........12
43............................43
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
`,
  },
  {
    id: "aztec",
    name: "Aztec",
    sourceFile: "aztec.layout",
    raw: String.raw`
kmahjongg-layout-v1.0
................................
..12........................12..
..43.....12121212121212.....43..
.1212....43434343434343....1212.
.4343....12121212121212....4343.
.121212124343434343434312121212.
.434343431212121212121243434343.
.121212124343434343434312121212.
.434343431212121212121243434343.
.121212124343434343434312121212.
.434343431212121212121243434343.
.1212....43434343434343....1212.
.4343....12121212121212....4343.
..12.....43434343434343.....12..
..43........................43..
................................
................................
..12........................12..
..43.....12..........12.....43..
.........43..........43.........
...........1212121212...........
...........4343434343...........
...121212..1212121212..121212...
...434343..4343434343..434343...
...121212..1212121212..121212...
...434343..4343434343..434343...
...........1212121212...........
...........4343434343...........
.........12..........12.........
..12.....43..........43.....12..
..43........................43..
................................
................................
................................
................................
................................
...........12......12...........
...........43......43...........
............12121212............
...1212.....43434343.....1212...
...4343.....12121212.....4343...
............43434343............
...........12......12...........
...........43......43...........
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
....12......12121212......12....
....43......43434343......43....
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
.............12..12.............
.............43..43.............
................................
................................
................................
................................
................................
................................
................................
`,
  },
  {
    id: "balance",
    name: "Balance",
    sourceFile: "balance.layout",
    raw: String.raw`
kmahjongg-layout-v1.0
...............12...............
.....1212121212431212121212.....
.....4343434343124343434343.....
.....12........43........12.....
.....43........12........43.....
...121212......43......121212...
...434343......12......434343...
...12..12......43......12..12...
...43..43......12......43..43...
.1212121212....43....1212121212.
.4343434343....12....4343434343.
....1212.......43.......1212....
....4343.......12.......4343....
...............43...............
.......121212121212121212.......
.......434343434343434343.......
...............12...............
.....1212121212431212121212.....
.....4343434343124343434343.....
.....12........43........12.....
.....43........12........43.....
...12..12......43......12..12...
...43..43......12......43..43...
...............43...............
...............12...............
..12121212.....43.....12121212..
..43434343.....12.....43434343..
.....12........43........12.....
.....43........12........43.....
...............43...............
........1212121212121212........
........4343434343434343........
...............12...............
.....12........43........12.....
.....43........12........43.....
.....12........43........12.....
.....43........12........43.....
...12..12......43......12..12...
...43..43......12......43..43...
...............43...............
...............12...............
...121212......43......121212...
...434343......12......434343...
.....12........43........12.....
.....43........12........43.....
...............43...............
..........121212121212..........
..........434343434343..........
...............12...............
.....12........43........12.....
.....43........12........43.....
...............43...............
................................
................................
................................
................................
................................
....1212................1212....
....4343................4343....
.....12..................12.....
.....43..................43.....
................................
............12121212............
............43434343............
...............12...............
.....12........43........12.....
.....43........12........43.....
...............43...............
................................
................................
................................
................................
................................
.....12..................12.....
.....43..................43.....
................................
................................
................................
..............1212..............
..............4343..............
`,
  },
  {
    id: "bat",
    name: "Bat",
    sourceFile: "bat.layout",
    raw: String.raw`
kmahjongg-layout-v1.0
...12......................12...
.1243.......12121212.......4312.
.431212.....43434343.....121243.
.124343.......1212.......434312.
.4312121212...4343...1212121243.
.1243434343...1212...4343434312.
.431212121212.4343.121212121243.
.124343434343121212434343434312.
.431212121212434343121212121243.
.124343434343121212434343434312.
.431212121212434343121212121243.
.124343434343..12..434343434312.
.431212..1212..43..1212..121243.
.124343..4343......4343..434312.
.4312......12......12......1243.
...43......43......43......43...
...12......................12...
...43..........12..........43...
...12..........43..........12...
...43..........12..........43...
...12..12......43......12..12...
...43..43......12......43..43...
.121212..12....43....12..121212.
.434343..43....12....43..434343.
.121212..12....43....12..121212.
.434343..43....12....43..434343.
...12..12......43......12..12...
...43..43..............43..43...
...12......................12...
...43......................43...
...12......12......12......12...
...43......43......43......43...
...12......................12...
...43......................43...
...12......................12...
...43......................43...
...12......................12...
...43......................43...
................................
................................
................................
................................
...12......................12...
...43......................43...
...12......................12...
...43......................43...
...12......................12...
...43......................43...
...12......................12...
...43......................43...
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
...12......................12...
...43......................43...
...12......................12...
...43......................43...
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
...12......................12...
...43......................43...
`,
  },
  {
    id: "bug",
    name: "Bug",
    sourceFile: "bug.layout",
    raw: String.raw`
kmahjongg-layout-v1.0
..........12....12....12........
..........4312..4312..4312......
............43....43....43......
...12......1212121212121212.....
...4312....434343434343434312...
.....43..1212121212121212124312.
.......124343434343434343431243.
.....12431212121212121212124312.
.....43124343434343434343431243.
.......431212121212121212124312.
.....12..4343434343434343431243.
...1243....121212121212121243...
...43......4343434343434343.....
............12....12....12......
..........1243..1243..1243......
..........43....43....43........
..........12....12....12........
..........43....43....43........
................................
...12...........................
...43...........................
...........1212121212121212.....
.......12..4343434343434343.....
.....124312121212121212121212...
.....431243434343434343434343...
.......43..1212121212121212.....
...........4343434343434343.....
...12...........................
...43...........................
................................
..........12....12....12........
..........43....43....43........
................................
................................
................................
...12...........................
...43...........................
............12121212121212......
.......12...43434343434343......
.......43..12121212121212.......
.......12..43434343434343.......
.......43...12121212121212......
............43434343434343......
...12...........................
...43...........................
................................
................................
................................
................................
................................
................................
................................
................................
................................
.......12.......................
.......43...121212121212........
.......12...434343434343........
.......43.......................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
.............1212121212.........
.............4343434343.........
................................
................................
................................
................................
................................
................................
................................
`,
  },
  {
    id: "chains",
    name: "Chains",
    sourceFile: "chains.layout",
    raw: String.raw`
kmahjongg-layout-v1.0
12121212121212121212121212121212
43434343434343434343434343434343
...12......12......12......12...
.124312..124312..124312..124312.
.43..43..43..43..43..43..43..43.
.12..12..12..12..12..12..12..12.
.431243..431243..431243..431243.
...43......43......43......43...
...12......12......12......12...
.124312..124312..124312..124312.
.43..43..43..43..43..43..43..43.
.12..12..12..12..12..12..12..12.
.431243..431243..431243..431243.
...43......43......43......43...
12121212121212121212121212121212
43434343434343434343434343434343
...12......12......12......12...
...43......43......43......43...
...12......12......12......12...
...43......43......43......43...
................................
................................
...12......12......12......12...
...43......43......43......43...
...12......12......12......12...
...43......43......43......43...
................................
................................
...12......12......12......12...
...43......43......43......43...
...12......12......12......12...
...43......43......43......43...
................................
................................
...12......12......12......12...
...43......43......43......43...
................................
................................
...12......12......12......12...
...43......43......43......43...
...12......12......12......12...
...43......43......43......43...
................................
................................
...12......12......12......12...
...43......43......43......43...
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
`,
  },
  {
    id: "checkered",
    name: "Checkered",
    sourceFile: "checkered.layout",
    raw: String.raw`
kmahjongg-layout-v1.0
.12..........................12.
.431212121212121212121212121243.
...43434343434343434343434343...
...12121212121212121212121212...
...43434343434343434343434343...
...12121212121212121212121212...
...43434343434343434343434343...
...12121212121212121212121212...
...43434343434343434343434343...
...12121212121212121212121212...
...43434343434343434343434343...
...12121212121212121212121212...
...43434343434343434343434343...
...12121212121212121212121212...
.124343434343434343434343434312.
.43..........................43.
.12..........................12.
.43..12..12..12..12..12..12..43.
.....43..43..43..43..43..43.....
...12..12..12..12..12..12..12...
...43..43..43..43..43..43..43...
.....12..12..12..12..12..12.....
.....43..43..43..43..43..43.....
...12..12..12..12..12..12..12...
...43..43..43..43..43..43..43...
.....12..12..12..12..12..12.....
.....43..43..43..43..43..43.....
...12..12..12..12..12..12..12...
...43..43..43..43..43..43..43...
.....12..12..12..12..12..12.....
.12..43..43..43..43..43..43..12.
.43..........................43.
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
`,
  },
  {
    id: "chip",
    name: "Chip",
    sourceFile: "chip.layout",
    raw: String.raw`
kmahjongg-layout-v1.0
................................
......12..12..12..12.12.........
......43..43..43..43.43.........
......12121212121212121212......
..1212434343434343434343431212..
..4343121212121212121212124343..
......43434343434343434343......
..1212121212121212121212121212..
..4343434343434343434343434343..
......12121212121212121212......
..1212434343434343434343431212..
..4343121212121212121212124343..
......43434343434343434343......
......12..12..12..12..12........
......43..43..43..43..43........
................................
................................
................................
................................
......12121212121212121212......
....124343434343434343434312....
....431212121212121212121243....
......43434343434343434343......
....12121212........12121212....
....43434343........43434343....
......12121212121212121212......
....124343434343434343434312....
....431212121212121212121243....
......43434343434343434343......
................................
................................
................................
................................
................................
................................
................................
................................
........1212121212121212........
........4343434343434343........
........12............12........
........43............43........
........1212121212121212........
........4343434343434343........
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
........12............12........
........43............43........
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
`,
  },
  {
    id: "clubs",
    name: "Clubs",
    sourceFile: "clubs.layout",
    raw: String.raw`
kmahjongg-layout-v1.0
...12......12......12......12...
.124312..124312..124312..124312.
.43..43..43..43..43..43..43..43.
12....1212....1212....1212....12
43....4343....4343....4343....43
.12..12..12..12..12..12..12..12.
.431243..431243..431243..431243.
...43......43......43......43...
...12......12......12......12...
.124312..124312..124312..124312.
.43..43..43..43..43..43..43..43.
12....1212....1212....1212....12
43....4343....4343....4343....43
.12..12..12..12..12..12..12..12.
.431243..431243..431243..431243.
...43......43......43......43...
................................
................................
................................
.......12......12......12.......
.......43......43......43.......
................................
................................
...12......12......12......12...
...43......43......43......43...
................................
................................
.......12......12......12.......
.......43......43......43.......
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
`,
  },
  {
    id: "columns",
    name: "Columns",
    sourceFile: "columns.layout",
    raw: String.raw`
kmahjongg-layout-v1.0
.......121212121212121212.......
.....1243434343434343434312.....
.....431212....12....121243.....
.1212124343....43....4343121212.
.43434312..1212121212..12434343.
.12....43..4343434343..43....12.
.43....12..12......12..12....43.
.12....43..4312121243..43....12.
.43....12..1243434312..12....43.
.12....43..43......43..43....12.
.43....12..1212121212..12....43.
.12121243..4343434343..43121212.
.4343431212....12....1212434343.
.....124343....43....434312.....
.....4312121212121212121243.....
.......434343434343434343.......
.......12..............12.......
.......43..............43.......
................................
.1212......................1212.
.4343......12......12......4343.
.12....12..43......43..12....12.
.43....43..............43....43.
.......12......12......12.......
.......43......43......43.......
.12....12..............12....12.
.43....43..12......12..43....43.
.1212......43......43......1212.
.4343......................4343.
................................
.......12..............12.......
.......43..............43.......
.......12..............12.......
.......43..............43.......
................................
.12..........................12.
.43........12......12........43.
...........43......43...........
................................
.......12......12......12.......
.......43......43......43.......
................................
...........12......12...........
.12........43......43........12.
.43..........................43.
................................
.......12..............12.......
.......43..............43.......
.......12..............12.......
.......43..............43.......
................................
.12..........................12.
.43........12......12........43.
...........43......43...........
................................
.......12......12......12.......
.......43......43......43.......
................................
...........12......12...........
.12........43......43........12.
.43..........................43.
................................
.......12..............12.......
.......43..............43.......
.......12..............12.......
.......43..............43.......
................................
.12..........................12.
.43........12......12........43.
...........43......43...........
................................
...............12...............
...............43...............
................................
...................12...........
.12................43........12.
.43..........................43.
................................
.......12..............12.......
.......43..............43.......
`,
  },
  {
    id: "cross",
    name: "Cross",
    sourceFile: "cross.layout",
    raw: String.raw`
kmahjongg-layout-v1.0
12....12121212121212121212....12
4312..43434343434343434343..1243
124312........1212........124312
43124312......4343......12431243
..43124312....1212....12431243..
....43124312..4343..12431243....
......43124312121212431243......
........4312434343431243........
........1243121212124312........
......12431243434343124312......
....12431243..1212..43124312....
..12431243....4343....43124312..
12431243......1212......43124312
431243........4343........431243
1243..12121212121212121212..4312
43....43434343434343434343....43
12......1212121212121212......12
4312....4343434343434343....1243
124312........1212........124312
43124312......4343......12431243
..43124312....1212....12431243..
....431243....4343....431243....
......4312....1212....1243......
........43....4343....43........
........12....1212....12........
......1243....4343....4312......
....124312....1212....124312....
..12431243....4343....43124312..
12431243......1212......43124312
431243........4343........431243
1243....1212121212121212....4312
43......4343434343434343......43
12........121212121212........12
4312......434343434343......1243
124312........1212........124312
43124312......4343......12431243
..43124312....1212....12431243..
....431243....4343....431243....
......4312....1212....1243......
........43....4343....43........
........12....1212....12........
......1243....4343....4312......
....124312....1212....124312....
..12431243....4343....43124312..
12431243......1212......43124312
431243........4343........431243
1243......121212121212......4312
43........434343434343........43
...............12...............
...............43...............
...............12...............
...............43...............
...............12...............
...............43...............
...............12...............
...............43...............
...............12...............
...............43...............
...............12...............
...............43...............
...............12...............
...............43...............
...............12...............
...............43...............
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
`,
  },
  {
    id: "eagle",
    name: "Eagle",
    sourceFile: "eagle.layout",
    raw: String.raw`
kmahjongg-layout-v1.0
..............121212............
..............43434312..........
..............1212..43..........
......1212....4343....1212......
....124343121212121212434312....
....431212434343434343121243....
....124343121212121212434312....
....431212434343434343121243....
..12124343....1212....43431212..
..434312......4343......124343..
..121243......1212......431212..
..4343........4343........4343..
..12........12.12.12........12..
..43........43.43.43........43..
..........12.12..12.12..........
..........43.43..43.43..........
..............121212............
..............434343............
..............1212..............
..............4343..............
....12121212..1212..12121212....
....43434343..4343..43434343....
....12121212..1212..12121212....
....43434343..4343..43434343....
...12.........1212.........12...
...43.12......4343......12.43...
...12.43......1212......43.12...
...43.........4343.........43...
............12....12............
............43....43............
..........12.12..12.12..........
..........43.43..43.43..........
..............121212............
..............434343............
................................
..............1212..............
.....121212...4343...121212.....
.....434343...1212...434343.....
.....121212...4343...121212.....
.....434343...1212...434343.....
..............4343..............
...12.........1212.........12...
...43.........4343.........43...
................................
................................
................................
..........12.12..12.12..........
..........43.43..43.43..........
................12..............
................43..............
................................
...............12...............
......1212.....43.....1212......
......4343.....12.....4343......
......1212.....43.....1212......
......4343.....12.....4343......
...............43...............
...............12...............
...............43...............
................................
................................
................................
................................
................................
................................
................................
................................
................................
.......12..............12.......
.......43..............43.......
.......12..............12.......
.......43..............43.......
................................
................................
................................
................................
................................
................................
................................
................................
`,
  },
  {
    id: "enterprise",
    name: "Enterprise",
    sourceFile: "enterprise.layout",
    raw: String.raw`
kmahjongg-layout-v1.0
................................
................................
................................
......12121212121212121212......
......43434343434343434343......
12121212121212121212121212121212
43434343434343434343434343434343
................12..............
................43..............
..............12................
............1243................
............43............12....
121212121212121212......124312..
434343434343434343......431243..
..........................43....
................................
................................
................................
................................
.......121212121212121212.......
.......434343434343434343.......
..1212121212121212121212121212..
..4343434343434343434343434343..
................12..............
................43..............
..............12................
............1243................
............43..................
..1212121212121212........12....
..4343434343434343........43....
................................
................................
................................
................................
................................
.........12121212121212.........
.........43434343434343.........
...12121212121212121212121212...
...43434343434343434343434343...
................12..............
................43..............
..............12................
............1243................
............43..................
....12121212121212........12....
....43434343434343........43....
................................
................................
................................
................................
................................
..........1212121212............
..........4343434343............
....1212121212121212121212......
....4343434343434343434343......
................12..............
................43..............
..............12................
............1243................
............43..................
......1212121212................
......4343434343................
................................
................................
................................
................................
................................
................................
................................
.......1212121212121212.........
.......4343434343434343.........
................................
................................
................................
................................
................................
........12121212................
........43434343................
................................
................................
`,
  },
  {
    id: "explosion",
    name: "Explosion",
    sourceFile: "explosion.layout",
    raw: String.raw`
kmahjongg-layout-v1.0
...12...12...121212...12...12...
.124312.43...434343...43.124312.
.431243.12..12121212..12.431243.
.124312.43..43434343..43.124312.
.431243....1212121212....431243.
...43....12434343434312....43...
.......124312......124312.......
121212.431243..12..431243.121212
434343.124312..43..124312.434343
.......431243......431243.......
...12....43121212121243....12...
.124312....4343434343....124312.
.431243.12..12121212..12.431243.
.124312.43..43434343..43.124312.
.431243.12...121212...12.431243.
...43...43...434343...43...43...
...............12...............
...12...12.....43.....12...12...
.124312.43...121212...43.124312.
.431243......434343......431243.
...43..........12..........43...
...............43...............
.........12..........12.........
.1212..124312..12..124312..1212.
.4343..431243..43..431243..4343.
.........43..........43.........
...............12...............
...12..........43..........12...
.124312......121212......124312.
.431243.12...434343...12.431243.
...43...43.....12.....43...43...
...............43...............
................................
................................
...12..........12..........12...
...43..........43..........43...
................................
................................
................................
..12.....12..........12.....12..
..43.....43..........43.....43..
................................
................................
................................
...12..........12..........12...
...43..........43..........43...
................................
................................
................................
................................
...12......................12...
...43......................43...
................................
................................
................................
................................
................................
................................
................................
................................
...12......................12...
...43......................43...
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
`,
  },
  {
    id: "flowers",
    name: "Flowers",
    sourceFile: "flowers.layout",
    raw: String.raw`
kmahjongg-layout-v1.0
..12121212..12121212..12121212..
..43434343..43434343..43434343..
..12....12..12....12..12....12..
..43....43..43....43..43....43..
..12121212..12121212..12121212..
..43434343..43434343..43434343..
.....12........12........12.....
.....4312121212431212121243.....
.....1243434343124343434312.....
.....43........43........43.....
..12121212..12121212..12121212..
..43434343..43434343..43434343..
..12....12..12....12..12....12..
..43....43..43....43..43....43..
..12121212..12121212..12121212..
..43434343..43434343..43434343..
..12121212....1212......1212....
..43434343....4343......4343....
..12....12..12....12..12....12..
..43....43..43....43..43....43..
..12121212....1212......1212....
..43434343....4343......4343....
................................
................................
................................
................................
....1212......1212......1212....
....4343......4343......4343....
..12....12..12....12..12....12..
..43....43..43....43..43....43..
....1212......1212......1212....
....4343......4343......4343....
....1212.......12........12.....
....4343.......43........43.....
..12....12..12....12..12....12..
..43....43..43....43..43....43..
....1212.......12........12.....
....4343.......43........43.....
................................
................................
................................
................................
.....12........12........12.....
.....43........43........43.....
..12....12..12....12..12....12..
..43....43..43....43..43....43..
.....12........12........12.....
.....43........43........43.....
.....12.........................
.....43.........................
..12....12......................
..43....43......................
.....12.........................
.....43.........................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
`,
  },
  {
    id: "future",
    name: "Future",
    sourceFile: "future.layout",
    raw: String.raw`
kmahjongg-layout-v1.0
................................
.......121212121212121212.......
.......434343434343434343.......
.......121212121212121212.......
.......434343434343434343.......
.....1212121212121212121212.....
...12434343434343434343434312...
.124312121212121212121212124312.
.431243434343434343434343431243.
...43121212121212121212121243...
.....4343434343434343434343.....
.......121212121212121212.......
.......434343434343434343.......
.......121212121212121212.......
.......434343434343434343.......
................................
................................
.......12......12......12.......
.......43......43......43.......
.........12....12....12.........
.........43....43....43.........
...........1212121212...........
...........4343434343...........
...12121212121212121212121212...
...43434343434343434343434343...
...........1212121212...........
...........4343434343...........
.........12....12....12.........
.........43....43....43.........
.......12......12......12.......
.......43......43......43.......
................................
................................
.......12..............12.......
.......43..............43.......
.........12..........12.........
.........43..........43.........
..............1212..............
..............4343..............
.....1212121212121212121212.....
.....4343434343434343434343.....
..............1212..............
..............4343..............
.........12..........12.........
.........43..........43.........
.......12..............12.......
.......43..............43.......
................................
................................
................................
................................
................................
................................
................................
................................
.........12121212121212.........
.........43434343434343.........
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
............12121212............
............43434343............
................................
................................
................................
................................
................................
................................
................................
`,
  },
  {
    id: "galaxy",
    name: "Galaxy",
    sourceFile: "galaxy.layout",
    raw: String.raw`
kmahjongg-layout-v1.0
...............12...............
..1212.........43.........1212..
..4343.......121212.......4343..
.121212......434343......121212.
.434343....1212121212....434343.
..1212.....4343434343.....1212..
..4343...12121212121212...4343..
.......124343434343434312.......
.......431212121212121243.......
..1212...43434343434343...1212..
..4343.....1212121212.....4343..
.121212....4343434343....121212.
.434343......121212......434343.
..1212.......434343.......1212..
..4343.........12.........4343..
...............43...............
................................
...12..........12..........12...
...43..........43..........43...
..1212.......121212.......1212..
..4343.......434343.......4343..
...12......1212121212......12...
...43......4343434343......43...
.........12121212121212.........
.........43434343434343.........
...12......1212121212......12...
...43......4343434343......43...
..1212.......121212.......1212..
..4343.......434343.......4343..
...12..........12..........12...
...43..........43..........43...
................................
................................
................................
................................
...12......................12...
...43........121212........43...
.............434343.............
...........1212121212...........
...........4343434343...........
...........1212121212...........
...........4343434343...........
.............121212.............
...12........434343........12...
...43..........12..........43...
...............43...............
................................
................................
................................
................................
................................
................................
................................
.............121212.............
.............434343.............
...........1212121212...........
...........4343434343...........
.............121212.............
.............434343.............
...............12...............
...............43...............
................................
................................
................................
................................
................................
................................
................................
................................
...............12...............
...............43...............
.............12..12.............
.............43..43.............
...............12...............
...............43...............
................................
................................
................................
................................
................................
`,
  },
  {
    id: "garden",
    name: "Garden",
    sourceFile: "garden.layout",
    raw: String.raw`
kmahjongg-layout-v1.0
...1212.......1212.......1212...
12.4343.12.12.4343.12.12.4343.12
4312121243.4312121243.4312121243
1243434312.1243434312.1243434312
4312121243.4312121243.4312121243
1243434312.1243434312.1243434312
43......43.43......43.43......43
..121212.....121212.....121212..
..434343.....434343.....434343..
12......12.12......12.12......12
4312121243.4312121243.4312121243
1243434312.1243434312.1243434312
4312121243.4312121243.4312121243
1243434312.1243434312.1243434312
43.1212.43.43.1212.43.43.1212.43
...4343.......4343.......4343...
....12.........12.........12....
....43.........43.........43....
................................
..121212.....121212.....121212..
..434343.....434343.....434343..
................................
................................
...1212.......1212.......1212...
...4343.......4343.......4343...
................................
................................
..121212.....121212.....121212..
..434343.....434343.....434343..
................................
....12.........12.........12....
....43.........43.........43....
................................
................................
................................
...1212.......1212.......1212...
...4343.......4343.......4343...
................................
................................
....12.........12.........12....
....43.........43.........43....
................................
................................
...1212.......1212.......1212...
...4343.......4343.......4343...
................................
................................
................................
................................
................................
................................
....12.........12.........12....
....43.........43.........43....
................................
................................
................................
................................
................................
................................
....12.........12.........12....
....43.........43.........43....
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
`,
  },
  {
    id: "girl",
    name: "Girl",
    sourceFile: "girl.layout",
    raw: String.raw`
kmahjongg-layout-v1.0
.......121212121212121212.......
.....1243434343434343434312.....
.....4312121212121212121243.....
.121212434343434343434343121212.
.434343121212121212121212434343.
.121212434343434343434343121212.
.434343..................434343.
.1212......12......12......1212.
.4343......43..12..43......4343.
.12.12.........43.........12.12.
.43.43.....12......12.....43.43.
.12...12...4312121243...12...12.
.43...43.....434343.....43...43.
.12.....12............12.....12.
.43.....4312121212121243.....43.
..........434343434343..........
.......121212121212121212.......
.....1243434343434343434312.....
.....4312121212121212121243.....
...12124343434343434343431212...
.124343....121212121212..434312.
.4312......434343434343..121243.
.1243....................434312.
.4312......................1243.
.1243......................4312.
.43.12....................12.43.
.12.43....................43.12.
.43...12................12...43.
......43................43......
........12............12........
........4312121212121243........
..........434343434343..........
.......121212121212121212.......
.....1243434343434343434312.....
.....43...12121212121212.43.....
...12.....43434343434343...12...
...43.........1212.........43...
.1212.........4343.........1212.
.4343......................4343.
.1212......................12...
.4343......................43...
....12....................12....
....43....................43....
......12................12......
......43................43......
................................
................................
................................
........1212121212121212........
........4343434343434343.12.....
.............121212......43.....
.............434343........12...
...........................43...
...........................12...
...........................43...
...........................12...
...........................43...
................................
................................
................................
................................
................................
................................
................................
............12121212............
............43434343............
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
`,
  },
  {
    id: "glade",
    name: "Glade",
    sourceFile: "glade.layout",
    raw: String.raw`
kmahjongg-layout-v1.0
1212........................1212
4343........................4343
1212........................1212
4343...121212121212121212...4343
.......434343434343434343.......
.......121212121212121212.......
.......434343434343434343.......
.......12121212..12121212.......
.......43434343..43434343.......
.......121212121212121212.......
.......434343434343434343.......
.......121212121212121212.......
1212...434343434343434343...1212
4343........................4343
1212........................1212
4343........................4343
.12..........................12.
.43..........................43.
.12..........................12.
.43......12121212121212......43.
.........43434343434343.........
.......121212121212121212.......
.......434343434343434343.......
.......121212......121212.......
.......434343......434343.......
.......121212121212121212.......
.......434343434343434343.......
.........12121212121212.........
.12......43434343434343......12.
.43..........................43.
.12..........................12.
.43..........................43.
................................
.12..........................12.
.43..........................43.
.........121212..121212.........
.........434343..434343.........
.......1212..........1212.......
.......4343..........4343.......
.......12..............12.......
.......43..............43.......
.......1212..........1212.......
.......4343..........4343.......
.........121212..121212.........
.........434343..434343.........
.12..........................12.
.43..........................43.
................................
................................
................................
................................
.........12..........12.........
.........43..........43.........
.......12..............12.......
.......43..............43.......
................................
................................
.......12..............12.......
.......43..............43.......
.........12..........12.........
.........43..........43.........
................................
................................
................................
................................
................................
................................
.........12..........12.........
.........43..........43.........
................................
................................
................................
................................
................................
................................
.........12..........12.........
.........43..........43.........
................................
................................
................................
`,
  },
  {
    id: "grid",
    name: "Grid",
    sourceFile: "grid.layout",
    raw: String.raw`
kmahjongg-layout-v1.0
12121212121212121212121212121212
43434343434343434343434343434343
12..1212......1212......1212..12
43..4343......4343......4343..43
12121212121212121212121212121212
43434343434343434343434343434343
12..1212......1212......1212..12
43..4343......4343......4343..43
12..1212......1212......1212..12
43..4343......4343......4343..43
12121212121212121212121212121212
43434343434343434343434343434343
12..1212......1212......1212..12
43..4343......4343......4343..43
12121212121212121212121212121212
43434343434343434343434343434343
................................
................................
.....12........12........12.....
.....43........43........43.....
....1212......1212......1212....
....4343......4343......4343....
.....12........12........12.....
.....43........43........43.....
.....12........12........12.....
.....43........43........43.....
...121212....121212.....1212....
...434343....434343.....4343....
.....12........12........12.....
.....43........43........43.....
................................
................................
................................
................................
................................
................................
.....12........12........12.....
.....43........43........43.....
................................
................................
................................
................................
.....12........12........12.....
.....43........43........43.....
................................
................................
................................
................................
................................
................................
................................
................................
.....12........12........12.....
.....43........43........43.....
................................
................................
................................
................................
.....12........12........12.....
.....43........43........43.....
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
`,
  },
  {
    id: "helios",
    name: "Helios",
    sourceFile: "helios.layout",
    raw: String.raw`
kmahjongg-layout-v1.0
....1212................1212....
....4343................4343....
....1212................1212....
....4343................4343....
....121212..12121212..121212....
....434343..43434343..434343....
....1212121212....1212121212....
....4343434343.12.4343434343....
....1212121212.43.1212121212....
....4343434343....4343434343....
....121212..12121212..121212....
....434343..43434343..434343....
....1212................1212....
....4343................4343....
....1212................1212....
....4343................4343....
....1212................1212....
....4343................4343....
....1212................1212....
....4343................4343....
....12........1212........12....
....43........4343........43....
....12......12....12......12....
....4312121243.12.4312121243....
....1243434312.43.1243434312....
....43......43....43......43....
....12........1212........12....
....43........4343........43....
....1212................1212....
....4343................4343....
....1212................1212....
....4343................4343....
....1212................1212....
....4343................4343....
....12....................12....
....43....................43....
..............1212..............
..............4343..............
............12....12............
............43....43............
............12....12............
............43....43............
..............1212..............
..............4343..............
....12....................12....
....43....................43....
....1212................1212....
....4343................4343....
....1212................1212....
....4343................4343....
....12....................12....
....43....................43....
..............1212..............
..............4343..............
............12....12............
............43....43............
............12....12............
............43....43............
..............1212..............
..............4343..............
....12....................12....
....43....................43....
....1212................1212....
....4343................4343....
....12....................12....
....43....................43....
................................
................................
...............12...............
...............43...............
................................
............12....12............
............43....43............
................................
...............12...............
...............43...............
................................
................................
....12....................12....
....43....................43....
`,
  },
  {
    id: "hole",
    name: "Hole",
    sourceFile: "hole.layout",
    raw: String.raw`
kmahjongg-layout-v1.0
....121212121212121212121212....
....434343434343434343434343....
....121212121212121212121212....
....434343434343434343434343....
....121212121212121212121212....
....434343434343434343434343....
....1212121212....1212121212....
....4343434343....4343434343....
....1212121212....1212121212....
....4343434343....4343434343....
....121212121212121212121212....
....434343434343434343434343....
....121212121212121212121212....
....434343434343434343434343....
....121212121212121212121212....
....434343434343434343434343....
................................
................................
......12121212121212121212......
......43434343434343434343......
......12121212121212121212......
......43434343434343434343......
......12121212....12121212......
......43434343....43434343......
......12121212....12121212......
......43434343....43434343......
......12121212121212121212......
......43434343434343434343......
......12121212121212121212......
......43434343434343434343......
................................
................................
................................
................................
................................
................................
........1212121212121212........
........4343434343434343........
........121212....121212........
........434343....434343........
........121212....121212........
........434343....434343........
........1212121212121212........
........4343434343434343........
................................
................................
................................
................................
................................
................................
................................
................................
..........121212121212..........
..........434343434343..........
..........1212....1212..........
..........4343....4343..........
..........1212....1212..........
..........4343....4343..........
..........121212121212..........
..........434343434343..........
................................
................................
................................
................................
................................
................................
................................
................................
............12121212............
............43434343............
............12....12............
............43....43............
............12....12............
............43....43............
............12121212............
............43434343............
................................
................................
................................
................................
`,
  },
  {
    id: "inner-circle",
    name: "Inner Circle",
    sourceFile: "inner_circle.layout",
    raw: String.raw`
kmahjongg-layout-v1.0
..1212....................1212..
..4343....................4343..
..1212121212121212121212121212..
..4343434343434343434343434343..
....12....................12....
....43..121212....121212..43....
....12..434343....434343..12....
....43..12............12..43....
....12..43............43..12....
....43..1212121212121212..43....
....12..4343434343434343..12....
....43....................43....
..121212121212....121212121212..
..434343434343....434343434343..
..1212......12....12......1212..
..4343......43....43......4343..
................................
................................
....1212121212....1212121212....
....4343434343....4343434343....
....12....................12....
....43..121212....121212..43....
....12..434343....434343..12....
....43................12..43....
....12................43..12....
....43..1212121212121212..43....
....12..4343434343434343..12....
....43....................43....
....1212121212....1212121212....
....4343434343....4343434343....
................................
................................
................................
................................
....121212............121212....
....434343............434343....
....12....................12....
....43..1212........1212..43....
........4343........4343........
................................
................................
........121212....121212........
....12..434343....434343..12....
....43....................43....
....121212............121212....
....434343............434343....
................................
................................
................................
................................
....12....................12....
....43....................43....
................................
........12............12........
........43............43........
................................
................................
........1212........1212........
........4343........4343........
................................
....12....................12....
....43....................43....
................................
................................
................................
................................
....12....................12....
....43....................43....
................................
................................
................................
................................
................................
........12............12........
........43............43........
................................
....12..........................
....43..........................
................................
................................
`,
  },
  {
    id: "key",
    name: "Key",
    sourceFile: "key.layout",
    raw: String.raw`
kmahjongg-layout-v1.0
................................
................................
................................
....12..........................
..124312........................
..43..43..........12121212121212
1212..12121212121243434343434343
4343..43434343434312121212121212
..12..12..........43434343434343
..431243..........12121212121212
....43............43434343434343
..................121212..12..12
..................434343..43..43
................................
................................
................................
................................
................................
................................
....12..........................
..124312........................
..43..43..........12121212121212
1212..12121212121243434343434343
4343..43434343434312121212121212
..12..12..........43434343434343
..431243..........12121212121212
....43............43434343434343
..................12..12..12..12
..................43..43..43..43
................................
................................
................................
................................
................................
................................
....12..........................
....43..........................
..................12121212121212
..12..12121212121243434343434343
..43..43434343434312121212121212
..................43434343434343
....12............12......12....
....43............43......43....
..................12..12..12..12
..................43..43..43..43
................................
................................
................................
................................
................................
................................
....12..........................
....43..........................
..................12121212121212
..12..12..........43434343434343
..43..43..........12............
..................43............
....12..........................
....43..........................
..................12..12..12..12
..................43..43..43..43
................................
................................
................................
................................
................................
................................
................................
................................
..................12..........12
..................43..........43
................................
................................
................................
................................
..................12..12..12..12
..................43..43..43..43
................................
................................
................................
`,
  },
  {
    id: "km",
    name: "KM",
    sourceFile: "km.layout",
    raw: String.raw`
kmahjongg-layout-v1.0
................................
................................
..1212....1212..1212......1212..
..4343....4343..4343......4343..
..1212..1212....121212..121212..
..4343..4343....43434312434343..
..12121212......12121243121212..
..43434343......43434312434343..
..12121212......1212..43..1212..
..43434343......4343..12..4343..
..1212..1212....1212..43..1212..
..4343..4343....4343......4343..
..1212....1212..1212......1212..
..4343....4343..4343......4343..
................................
................................
................................
................................
..1212....12....1212......1212..
..4343....43....4343......4343..
..12....12......12..12..12..12..
..43....43......43..431243..43..
..12..12........12....43....12..
..43124312......43....12....43..
..12431243......12....43....12..
..43..43........43....12....43..
..12....12......12....43....12..
..43....43......43..........43..
..1212....12....1212......1212..
..4343....43....4343......4343..
................................
................................
................................
................................
..................12......12....
..12............1243......4312..
..43............43..12..12..43..
..12............12..431243..12..
..43............43....43....43..
..121212........12....12....12..
..434343........43....43....43..
..12............12....12....12..
..43............43....43....43..
..12............12..........12..
..43............43..........43..
................................
................................
................................
................................
................................
................................
................................
..12............12..12..12..12..
..43............43..431243..43..
..12............12....43....12..
..4312..........43....12....43..
..1243..........12....43....12..
..43............43....12....43..
..12............12....43....12..
..43............43..........43..
................................
................................
................................
................................
................................
................................
................................
................................
................................
..12............12..........12..
..43............43..........43..
..12............12....12....12..
..43............43....43....43..
..12............12..........12..
..43............43..........43..
................................
................................
................................
................................
................................
`,
  },
  {
    id: "labyrinth",
    name: "Labyrinth",
    sourceFile: "labyrinth.layout",
    raw: String.raw`
kmahjongg-layout-v1.0
.121212..................121212.
.43434312....12..12....12434343.
.......43....43..43....43.......
.12...1212...12..12...1212...12.
.43...4343...43..43...4343...43.
.12..........12..12..........12.
.43..12..12..43..43..12..12..43.
.121243..431212..121243..431212.
.434312..124343..434312..124343.
.12..43..43..12..12..43..43..12.
.43..........43..43..........43.
.12...1212...12..12...1212...12.
.43...4343...43..43...4343...43.
.......12....121212....12.......
.12121243....434343....43121212.
.434343..................434343.
.1212......................1212.
.4343........12..12........4343.
.............43..43.............
.12..........................12.
.43..........................43.
................................
.........12..........12.........
.1212....43..12..12..43....1212.
.4343....12..43..43..12....4343.
.........43..........43.........
................................
.12..........................12.
.43..........................43.
................................
.1212......................1212.
.4343......................4343.
.12..........................12.
.43..........12..12..........43.
.............43..43.............
.12..........................12.
.43..........................43.
................................
.........12..........12.........
.12......43..........43......12.
.43......12..........12......43.
.........43..........43.........
................................
.12..........................12.
.43..........................43.
................................
.12..........................12.
.43..........................43.
................................
.............12..12.............
.............43..43.............
................................
................................
................................
.....................12.........
.12......12..........43......12.
.43......43..........12......43.
.....................43.........
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
.........12..........12.........
.........43..........43.........
................................
................................
................................
................................
................................
................................
................................
`,
  },
  {
    id: "mask",
    name: "Mask",
    sourceFile: "mask.layout",
    raw: String.raw`
kmahjongg-layout-v1.0
..1212121212121212121212121212..
..4343434343434343434343434343..
12121212121212121212121212121212
43434343434343434343434343434343
12121212121212121212121212121212
43434343434343434343434343434343
..1212121212121212121212121212..
..4343434343434343434343434343..
..1212121212121212121212121212..
..4343434343434343434343434343..
....12121212..12..12..121212....
....43434343..43..43..434343....
......1212..12..12..121212......
......4343..43..43..434343......
........1212121212121212........
........4343434343434343........
..121212121212....121212121212..
..434343434343....434343434343..
12..........12....12..........12
43....12....43....43....12....43
1212..43....12....12....43..1212
4343........43....43........4343
..1212121212121212121212121212..
..4343434343434343434343434343..
......12121212121212121212......
......43434343434343434343......
........12............12........
........43............43........
........12............12........
........43............43........
..........121212121212..........
..........434343434343..........
..12121212............12121212..
..43434343............43434343..
................................
................................
................................
................................
..............1212..............
..............4343..............
...............12...............
...............43...............
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
...............12...............
...............43...............
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
`,
  },
  {
    id: "maya",
    name: "Maya",
    sourceFile: "maya.layout",
    raw: String.raw`
kmahjongg-layout-v1.0
...1212121212......1212121212...
...4343434343......4343434343...
...1212121212......1212121212...
...4343434343......4343434343...
...12121212121212121212121212...
...43434343434343434343434343...
...........1212121212...........
...........4343434343...........
...........1212121212...........
...........4343434343...........
...12121212121212121212121212...
...43434343434343434343434343...
...1212121212......1212121212...
...4343434343......4343434343...
...1212121212......1212121212...
...4343434343......4343434343...
................................
.....121212..........121212.....
.....434343..........434343.....
.....121212..........121212.....
.....434343..........434343.....
.............121212.............
.............434343.............
.............121212.............
.............434343.............
.............121212.............
.............434343.............
.....121212..........121212.....
.....434343..........434343.....
.....121212..........121212.....
.....434343..........434343.....
................................
................................
................................
.....121212..........121212.....
.....434343..........434343.....
................................
..............1212..............
..............4343..............
..............1212..............
..............4343..............
..............1212..............
..............4343..............
................................
.....121212..........121212.....
.....434343..........434343.....
................................
................................
................................
................................
......1212............1212......
......4343............4343......
................................
...............12...............
...............43...............
...............12...............
...............43...............
...............12...............
...............43...............
................................
......1212............1212......
......4343............4343......
................................
................................
................................
................................
.......12..............12.......
.......43..............43.......
................................
................................
...............12...............
...............43...............
...............12...............
...............43...............
................................
................................
.......12..............12.......
.......43..............43.......
................................
................................
`,
  },
  {
    id: "maze",
    name: "Maze",
    sourceFile: "maze.layout",
    raw: String.raw`
kmahjongg-layout-v1.0
12121212121212121212121212121212
43434343434343434343434343434343
12121212121212121212121212121212
43434343434343434343434343434343
12121212121212121212121212121212
43434343434343434343434343434343
12121212121212121212121212121212
43434343434343434343434343434343
12121212121212121212121212121212
43434343434343434343434343434343
12121212121212121212121212121212
43434343434343434343434343434343
12121212121212121212121212121212
43434343434343434343434343434343
12121212121212121212121212121212
43434343434343434343434343434343
12..12121212121212121212..12..12
43..43434343434343434343..43..43
12........12..........12..12..12
43........43..........43..43..43
12..12121212..121212......12..12
43..43434343..434343......43..43
....12............121212..12....
....43............434343..43....
12..12..12121212121212....12..12
43..43..43434343434343....43..43
12........12........12..1212..12
43........43........43..4343..43
12..12121212..12....12..........
43..43434343..43....43..........
12..12........12....121212121212
43..43........43....434343434343
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
`,
  },
  {
    id: "mesh",
    name: "Mesh",
    sourceFile: "mesh.layout",
    raw: String.raw`
kmahjongg-layout-v1.0
................................
.121212..121212..121212..121212.
.434343..434343..434343..434343.
.12..12..12..12..12..12..12..12.
.43..43..43..43..43..43..43..43.
.121212121212121212121212121212.
.434343434343434343434343434343.
.....12..12..12..12..12..12.....
.....43..43..43..43..43..43.....
.121212121212121212121212121212.
.434343434343434343434343434343.
.12..12..12..12..12..12..12..12.
.43..43..43..43..43..43..43..43.
.121212..121212..121212..121212.
.434343..434343..434343..434343.
................................
................................
.121212..121212..121212..121212.
.434343..434343..434343..434343.
.12..12..12..12..12..12..12..12.
.43..43..43..43..43..43..43..43.
.121212..121212..121212..121212.
.434343..434343..434343..434343.
.........12..12..12..12.........
.........43..43..43..43.........
.121212..121212..121212..121212.
.434343..434343..434343..434343.
.12..12..12..12..12..12..12..12.
.43..43..43..43..43..43..43..43.
.121212..121212..121212..121212.
.434343..434343..434343..434343.
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
`,
  },
  {
    id: "moth",
    name: "Moth",
    sourceFile: "moth.layout",
    raw: String.raw`
kmahjongg-layout-v1.0
................................
12121212.....121212.....12121212
4343434312...434343...1243434343
..12..124312...12...124312..12..
..43..43124312.43.12431243..43..
...12...4312431212431243...12...
...43.....431243431243.....43...
..1212.1212.43121243.1212.1212..
..4343.4343.12434312.4343.4343..
...12.....124312124312.....12...
...43...1243124343124312...43...
..12..12431243.12.43124312..12..
..43..431243...43...431243..43..
..12121243.....12.....43121212..
12434343.......43.......43434312
43............................43
................................
12121212......1212......12121212
43434343......4343......43434343
..12....12.....12.....12....12..
..43....43.....43.....43....43..
............12121212............
............43434343............
...12...12....1212....12...12...
...43...43....4343....43...43...
............12121212............
............43434343............
..12....12.....12.....12....12..
..43....43.....43.....43....43..
..121212.......12.......121212..
12434343.......43.......43434312
43............................43
................................
..1212.........12.........1212..
..4343.........43.........4343..
...............12...............
...............43...............
.............121212.............
.............434343.............
...............12...............
...............43...............
.............121212.............
.............434343.............
...............12...............
...............43...............
..1212....................1212..
..4343....................4343..
................................
................................
...12......................12...
...43......................43...
................................
................................
..............1212..............
..............4343..............
...............12...............
...............43...............
..............1212..............
..............4343..............
................................
................................
...12......................12...
...43......................43...
................................
................................
................................
................................
................................
................................
...............12...............
...............43...............
................................
................................
...............12...............
...............43...............
................................
................................
................................
................................
................................
`,
  },
  {
    id: "order",
    name: "Order",
    sourceFile: "order.layout",
    raw: String.raw`
kmahjongg-layout-v1.0
........1212121212121212........
...12...4343434343434343...12...
...43......1212121212......43...
...121212..4343434343..121212...
...434343....121212....434343...
...121212....434343....121212...
...43434312121212121212434343...
...12121243434343434343121212...
...43434312121212121212434343...
...12121243434343434343121212...
...434343....121212....434343...
...121212....434343....121212...
...434343..1212121212..434343...
...12......4343434343......12...
...43...1212121212121212...43...
........4343434343434343........
.........12121212121212.........
.........43434343434343.........
..............1212..............
...12.........4343.........12...
...43..........12..........43...
...1212........43........1212...
...4343........12........4343...
...12121212121243121212121212...
...43434343434312434343434343...
...1212........43........1212...
...4343........12........4343...
...12..........43..........12...
...43.........1212.........43...
..............4343..............
.........12121212121212.........
.........43434343434343.........
.............121212.............
.............434343.............
...............12...............
...............43...............
................................
...12......................12...
...43......................43...
...1212........12........1212...
...4343........43........4343...
...12......................12...
...43......................43...
................................
...............12...............
...............43...............
.............121212.............
.............434343.............
................................
................................
................................
................................
................................
................................
................................
...............12...............
...............43...............
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
`,
  },
  {
    id: "pattern",
    name: "Pattern",
    sourceFile: "pattern.layout",
    raw: String.raw`
kmahjongg-layout-v1.0
................................
.1212.1212.1212.1212.1212.1212..
.4343.4343.4343.4343.4343.4343..
.1212.1212.1212.1212.1212.1212..
.4343.4343.4343.4343.4343.4343..
................................
.1212.1212.1212.1212.1212.1212..
.4343.4343.4343.4343.4343.4343..
.1212.1212.1212.1212.1212.1212..
.4343.4343.4343.4343.4343.4343..
................................
.1212.1212.1212.1212.1212.1212..
.4343.4343.4343.4343.4343.4343..
.1212.1212.1212.1212.1212.1212..
.4343.4343.4343.4343.4343.4343..
................................
................................
..12........12.........12.12....
..43..1212..43.........43.43....
..12..4343.......12..1212.1212..
..43.............43..4343.4343..
................................
.12.....12.1212..12..12.....12..
.43.....43.4343..43..43.....43..
...12.12....12..1212.12.....12..
...43.43....43..4343.43.....43..
................................
.............12.12...1212.1212..
.12.....12...43.43...4343.4343..
.43.....43.12.....12...12.12....
...........43.....43...43.43....
................................
................................
..12........12..................
..43..1212..43..................
..12..4343.......12....12.12....
..43.............43....43.43....
................................
.12.....12.1212..12..12.....12..
.43.....43.4343..43..43.....43..
...12.12....12..1212.12.....12..
...43.43....43..4343.43.....43..
................................
.............12.12...1212.1212..
.12.....12...43.43...4343.4343..
.43.....43.12.....12...12.12....
...........43.....43...43.43....
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
`,
  },
  {
    id: "penta",
    name: "Penta",
    sourceFile: "penta.layout",
    raw: String.raw`
kmahjongg-layout-v1.0
................................
...12121212..........12121212...
...43434343..........43434343...
...12121212121212121212121212...
...43434343434343434343434343...
...12121212.12121212.12121212...
...43434343.43434343.43434343...
......12....12121212....12......
......43....43434343....43......
...12121212.12121212.12121212...
...43434343.43434343.43434343...
...12121212121212121212121212...
...43434343434343434343434343...
...12121212..........12121212...
...43434343..........43434343...
................................
................................
...12....12..........12....12...
...43121243..........43121243...
.....4343..............4343.....
.....1212..............1212.....
...12434312.12....12.12434312...
...43....43.43121243.43....43...
............12434312............
............43121243............
...12....12.12434312.12....12...
...43121243.43....43.43121243...
.....4343..............4343.....
.....1212..............1212.....
...12434312..........12434312...
...43....43..........43....43...
................................
................................
................................
................................
.....1212..............1212.....
.....4343..............4343.....
................................
................................
..............1212..............
..............4343..............
................................
................................
.....1212..............1212.....
.....4343..............4343.....
................................
................................
................................
................................
................................
................................
......12................12......
......43................43......
................................
................................
...............12...............
...............43...............
................................
................................
......12................12......
......43................43......
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
...............12...............
...............43...............
................................
................................
................................
................................
................................
................................
................................
`,
  },
  {
    id: "pillars",
    name: "Pillars",
    sourceFile: "pillars.layout",
    raw: String.raw`
kmahjongg-layout-v1.0
12121212121212121212121212121212
43434343434343434343434343434343
....1212121212....1212121212....
....4343434343....4343434343....
......121212........121212......
......434343........434343......
......121212........121212......
......434343........434343......
......121212........121212......
......434343........434343......
......121212........121212......
......434343........434343......
....1212121212....1212121212....
....4343434343....4343434343....
12121212121212121212121212121212
43434343434343434343434343434343
...12121212121212121212121212...
...43434343434343434343434343...
.......1212..........1212.......
.......4343..........4343.......
........12............12........
........43............43........
........12............12........
........43............43........
........12............12........
........43............43........
........12............12........
........43............43........
.......1212..........1212.......
.......4343..........4343.......
...12121212121212121212121212...
...43434343434343434343434343...
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
`,
  },
  {
    id: "pirates",
    name: "Pirates",
    sourceFile: "pirates.layout",
    raw: String.raw`
kmahjongg-layout-v1.0
.............121212.......12..12
.............434343.......43..43
.............12.............12..
.........1212431212.........43..
.........4343124343.......12..12
.......12121243121212.....43..43
.......43434312434343...........
...1212121212431212121212.......
...4343434343124343434343....12.
12...........43..............43.
43...........12..........121212.
.12..........43..........434343.
.431212121212121212121212121212.
...4343434343434343434343434343.
.......1212121212121212121212...
.......4343434343434343434343...
.............12.................
.............43.................
.............12.............12..
.........12124312...........43..
.........43431243...............
.........1212431212.............
.........4343124343.............
.......12121243121212...........
.......43434312434343........12.
.............43..............43.
.............12..........121212.
.............43..........434343.
.....121212121212121212121212...
.....434343434343434343434343...
.........1212121212121212.......
.........4343434343434343.......
................................
................................
................................
...........12..12...............
...........43..43...............
.........1212..1212.............
.........4343..4343.............
.........1212..1212.............
.........4343..4343.............
................................
.............................12.
...........................1243.
......121212121212121212.1243...
......434343434343434343.43.....
.........1212121212121212.......
.........4343434343434343.......
................................
................................
................................
...........12..12...............
...........43..43...............
...........12..12...............
...........43..43...............
.........12......12.............
.........43......43.............
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
`,
  },
  {
    id: "pyramid",
    name: "Pyramid",
    sourceFile: "pyramid.layout",
    raw: String.raw`
kmahjongg-layout-v1.0
# Level 0 -------------------------
....121212121212121212121212....
....434343434343434343434343....
....121212121212121212121212....
....434343434343434343434343....
....121212121212121212121212....
....434343434343434343434343....
....121212121212121212121212....
....434343434343434343434343....
....121212121212121212121212....
....434343434343434343434343....
....121212121212121212121212....
....434343434343434343434343....
....121212121212121212121212....
....434343434343434343434343....
....121212121212121212121212....
....434343434343434343434343....
# Level 1 -------------------------
................................
................................
......12121212121212121212......
......43434343434343434343......
......12121212121212121212......
......43434343434343434343......
......12121212121212121212......
......43434343434343434343......
......12121212121212121212......
......43434343434343434343......
......12121212121212121212......
......43434343434343434343......
......12121212121212121212......
......43434343434343434343......
................................
................................
# Level 2 -------------------------
................................
................................
................................
................................
........1212121212121212........
........4343434343434343........
........1212121212121212........
........4343434343434343........
........1212121212121212........
........4343434343434343........
........1212121212121212........
........4343434343434343........
................................
................................
................................
................................
# Level 3 -------------------------
................................
................................
................................
................................
................................
................................
..........121212121212..........
..........434343434343..........
..........121212121212..........
..........434343434343..........
................................
................................
................................
................................
................................
................................
# Level 4 -------------------------
................................
................................
................................
................................
................................
................................
................................
............12121212............
............43434343............
................................
................................
................................
................................
................................
................................
................................
`,
  },
  {
    id: "rocket",
    name: "Rocket",
    sourceFile: "rocket.layout",
    raw: String.raw`
kmahjongg-layout-v1.0
............121212.......121212.
..........12434343.......434343.
........124312121212...12121212.
......1243124343434312.43434343.
....1243124312..1212431212......
..124312431243124343124343.12...
..431243..43..43..12431212.43...
121243121212121212431243431212..
434312434343434343124312124343..
..124312..12..12..43124343.12...
..431243124312431212431212.43...
....4312431243..4343124343......
......4312431212121243.12121212.
........431243434343...43434343.
..........43121212.......121212.
............434343.......434343.
.............1212...............
...........124343..........12...
.........12431212..........43...
.......1243..4343.12............
.....1243.........43...12.......
...1243...........12...43.......
...43.............4312..........
..121212121212121212431212......
..434343434343434343124343......
...12.............1243..........
...4312...........43...12.......
.....4312.........12...43.......
.......4312..1212.43............
.........43124343..........12...
...........431212..........43...
.............4343...............
................................
.............1212...............
.............4343...............
................................
................................
................................
..................12............
...121212121212.12431212........
...434343434343.43124343........
..................43............
................................
................................
................................
.............1212...............
.............4343...............
................................
................................
..............12................
..............43................
................................
................................
................................
................................
....121212........12............
....434343........43............
................................
................................
................................
................................
..............12................
..............43................
................................
................................
................................
................................
................................
................................
................................
................................
.....12.........................
.....43.........................
................................
................................
................................
................................
................................
................................
................................
`,
  },
  {
    id: "shield",
    name: "Shield",
    sourceFile: "shield.layout",
    raw: String.raw`
kmahjongg-layout-v1.0
.1212121212121212.......12......
.4343434343434343.......43......
.1212121212121212.......12......
.4343434343434343.......43......
.1212121212121212.......12......
.4343434343434343.......43......
..12121212121212........12......
..43434343434343........43......
...121212121212.........12......
...434343434343.....12..43..12..
.....12121212.......4312121243..
.....43434343.........434343....
.......1212.............12......
.......4343.............43......
........12..............12......
........43..............43......
................................
...121212121212.................
...434343434343.........12......
...121212121212.........43......
...434343434343.........12......
...121212121212.........43......
...434343434343.........12......
....1212121212..........43......
....4343434343..........12......
.....12121212.......12..43..12..
.....43434343.......4312121243..
.......1212...........434343....
.......4343.............12......
........................43......
........................12......
........................43......
................................
....1212121212..................
....4343434343..................
....1212121212..................
....4343434343..........12......
.....12121212...........43......
.....43434343...........12......
......121212............43......
......434343............12......
.......1212.........12..43..12..
.......4343.........43..12..43..
........12..............43......
........43..............12......
........................43......
........................12......
........................43......
................................
................................
......121212....................
......434343....................
......121212....................
......434343....................
.......1212.............12......
.......4343.............43......
........12..............12......
........43..........12..43..12..
....................43..12..43..
........................43......
................................
................................
........................12......
........................43......
................................
................................
................................
........12......................
........43......................
........12......................
........43......................
................................
................................
....................12......12..
....................43..12..43..
........................43......
................................
................................
................................
................................
`,
  },
  {
    id: "squares",
    name: "Squares",
    sourceFile: "squares.layout",
    raw: String.raw`
kmahjongg-layout-v1.0
.....1212121212121212121212.....
.....4343434343434343434343.....
.....12..................12.....
.....43.1212121212121212.43.....
.....12.4343434343434343.12.....
.....43.12............12.43.....
.....12.43.1212121212.43.12.....
.....43.12.4343434343.12.43.....
.....12.43.1212121212.43.12.....
.....43.12.4343434343.12.43.....
.....12.43............43.12.....
.....43.1212121212121212.43.....
.....12.4343434343434343.12.....
.....43..................43.....
.....1212121212121212121212.....
.....4343434343434343434343.....
.....1212121212121212121212.....
.....4343434343434343434343.....
................................
........12...121212...12........
........43...434343...43........
........12............12........
........43.1212121212.43........
........12.4343434343.12........
........43.1212121212.43........
........12.4343434343.12........
........43............43........
........12...121212...12........
........43...434343...43........
................................
.....1212121212121212121212.....
.....4343434343434343434343.....
.....12..12..12..12..12..12.....
.....43..43..43..43..43..43.....
................................
........12.....12.....12........
........43.....43.....43........
................................
.............121212.............
........12...434343...12........
........43...121212...43........
.............434343.............
................................
........12.....12.....12........
........43.....43.....43........
................................
.....12..12..12..12..12..12.....
.....43..43..43..43..43..43.....
................................
................................
................................
................................
................................
................................
..............1212..............
..............4343..............
..............1212..............
..............4343..............
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
`,
  },
  {
    id: "squaring",
    name: "Squaring",
    sourceFile: "squaring.layout",
    raw: String.raw`
kmahjongg-layout-v1.0
................................
................................
.121212..121212..121212..121212.
.434343..434343..434343..434343.
.12..12..121212..12..12..121212.
.43..43..434343..43..43..434343.
.121212..121212..121212..121212.
.434343..434343..434343..434343.
................................
.121212..121212..121212..121212.
.434343..434343..434343..434343.
.121212..12..12..121212..12..12.
.434343..43..43..434343..43..43.
.121212..121212..121212..121212.
.434343..434343..434343..434343.
................................
................................
................................
.12..12..12..12..12..12..12..12.
.43..43..43..43..43..43..43..43.
...........12..............12...
...........43..............43...
.12..12..12..12..12..12..12..12.
.43..43..43..43..43..43..43..43.
................................
.12..12..12..12..12..12..12..12.
.43..43..43..43..43..43..43..43.
...12..............12...........
...43..............43...........
.12..12..12..12..12..12..12..12.
.43..43..43..43..43..43..43..43.
................................
................................
................................
.12..12..12..12..12..12..12..12.
.43..43..43..43..43..43..43..43.
...........12..............12...
...........43..............43...
.12..12..12..12..12..12..12..12.
.43..43..43..43..43..43..43..43.
................................
.12..12..12..12..12..12..12..12.
.43..43..43..43..43..43..43..43.
...12..............12...........
...43..............43...........
.12..12..12..12..12..12..12..12.
.43..43..43..43..43..43..43..43.
................................
................................
................................
................................
................................
...........12..............12...
...........43..............43...
................................
................................
................................
................................
................................
...12..............12...........
...43..............43...........
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
`,
  },
  {
    id: "stadion",
    name: "Stadion",
    sourceFile: "stadion.layout",
    raw: String.raw`
kmahjongg-layout-v1.0
12121212121212121212121212121212
43434343434343434343434343434343
12.............12.............12
43.............43.............43
12.............12.............12
43..........12.43.12..........43
1212........43....43........1212
434312.....12..12..12.....124343
121243.....43..43..43.....431212
4343........12....12........4343
12..........43.12.43..........12
43.............43.............43
12.............12.............12
43.............43.............43
12121212121212121212121212121212
43434343434343434343434343434343
12121212121212121212121212121212
43434343434343434343434343434343
12.............12.............12
43.............43.............43
12.............12.............12
43..........12.43.12..........43
12..........43....43..........12
43.........12..12..12.........43
12.........43..43..43.........12
43..........12....12..........43
12..........43.12.43..........12
43.............43.............43
12.............12.............12
43.............43.............43
12121212121212121212121212121212
43434343434343434343434343434343
12............................12
43............................43
................................
................................
................................
................................
................................
...............12...............
...............43...............
................................
................................
................................
................................
................................
12............................12
43............................43
12............................12
43............................43
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
12............................12
43............................43
12............................12
43............................43
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
12..............................
43..............................
`,
  },
  {
    id: "stairs",
    name: "Stairs",
    sourceFile: "stairs.layout",
    raw: String.raw`
kmahjongg-layout-v1.0
...............12...............
.....12........43........12.....
.121243121212121212121212431212.
.434312434343434343434343124343.
.12..43..12....12....12..43..12.
.43..12..43....43....43..12..43.
.12..43..12....12....12..43..12.
.431212124312124312124312121243.
.124343431243431243431243434312.
.43..12..43....43....43..12..43.
.12..43..12....12....12..43..12.
.43..12..43....43....43..12..43.
.121243121212121212121212431212.
.434312434343434343434343124343.
.....43........12........43.....
...............43...............
................................
................................
.121212......121212......121212.
.434343......434343......434343.
.12..........................12.
.43..12........12........12..43.
.....43........43........43.....
.12121212....121212....12121212.
.43434343....434343....43434343.
.....12........12........12.....
.12..43........43........43..12.
.43..........................43.
.121212......121212......121212.
.434343......434343......434343.
................................
................................
................................
................................
.1212..........12..........1212.
.4343..........43..........4343.
.12..........................12.
.43..........................43.
................................
.....12........12........12.....
.....43........43........43.....
................................
.12..........................12.
.43..........................43.
.1212..........12..........1212.
.4343..........43..........4343.
................................
................................
................................
................................
.1212......................1212.
.4343......................4343.
.12..........................12.
.43..........................43.
................................
...............12...............
...............43...............
................................
.12..........................12.
.43..........................43.
.1212......................1212.
.4343......................4343.
................................
................................
................................
................................
.12..........................12.
.43..........................43.
................................
................................
................................
...............12...............
...............43...............
................................
................................
................................
.12..........................12.
.43..........................43.
................................
................................
`,
  },
  {
    id: "star-ship",
    name: "Star Ship",
    sourceFile: "star_ship.layout",
    raw: String.raw`
kmahjongg-layout-v1.0
................................
...............12...............
.12..........124312..........12.
.4312......1243..4312......1243.
.1243....1243......4312....4312.
.4312..1243....12....4312..1243.
.12431243....124312....43124312.
.431243121212431243121212431243.
.124312434343124312434343124312.
.43124312....431243....12431243.
.1243..4312....43....1243..4312.
.4312....4312......1243....1243.
.1243......4312..1243......4312.
.43..........431243..........43.
...............43...............
................................
................................
...............12...............
.............124312.............
.12........1243..4312........12.
.43......1243......4312......43.
.1212....43....12....43....1212.
.4343..........43..........4343.
.121212....1212121212....121212.
.434343....4343434343....434343.
.1212..........12..........1212.
.4343....12....43....12....4343.
.12......4312......1243......12.
.43........4312..1243........43.
.............431243.............
...............43...............
................................
................................
...............12...............
.............124312.............
...........1243..4312...........
.12........43......43........12.
.43............12............43.
.12............43............12.
.4312........121212........1243.
.1243........434343........4312.
.43............12............43.
.12............43............12.
.43........12......12........43.
...........4312..1243...........
.............431243.............
...............43...............
................................
................................
...............12...............
.............124312.............
.............43..43.............
................................
.12..........................12.
.43..........................43.
.1212..........12..........1212.
.4343..........43..........4343.
.12..........................12.
.43..........................43.
................................
.............12..12.............
.............431243.............
...............43...............
................................
................................
...............12...............
...............43...............
................................
................................
................................
.12..........................12.
.4312......................1243.
.1243......................4312.
.43..........................43.
................................
................................
................................
...............12...............
...............43...............
................................
`,
  },
  {
    id: "star",
    name: "Star",
    sourceFile: "star.layout",
    raw: String.raw`
kmahjongg-layout-v1.0
...............12...............
.......12......43......12.......
.......43.....1212.....43.......
.........12...4343...12.........
.........43..121212..43.........
...........1243434312...........
.........12431212124312.........
...12121243124343431243121212...
...43434312431212124312434343...
.........43124343431243.........
...........4312121243...........
.........12..434343..12.........
.........43...1212...43.........
.......12.....4343.....12.......
.......43......12......43.......
...............43...............
................................
.......................12.......
...............12......43.......
.........12....43....12.........
.........43..121212..43.........
...........1243434312...........
...........4312121243...........
...121212121243434312121212.....
...434343434312121243434343.....
...........1243434312...........
...........4312121243...........
.........12..434343..12.........
.........43....12....43.........
.......12......43......12.......
.......43..............43.......
................................
................................
................................
................................
.........12..........12.........
.........43..121212..43.........
...........1243434312...........
...........4312121243...........
.......121212434343121212.......
.......434343121212434343.......
...........1243434312...........
...........4312121243...........
.........12..434343..12.........
.........43..........43.........
................................
................................
................................
................................
................................
................................
................................
................................
.............121212.............
.............434343.............
.........12121212121212.........
.........43434343434343.........
.............121212.............
.............434343.............
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
...............12...............
...............43...............
...........1212121212...........
...........4343434343...........
...............12...............
...............43...............
................................
................................
................................
................................
................................
`,
  },
  {
    id: "stax",
    name: "Stacks",
    sourceFile: "stax.layout",
    raw: String.raw`
kmahjongg-layout-v1.0
................................
12121212..121212121212..12121212
43434343..434343434343..43434343
12............1212............12
43............4343............43
12121212......1212......12121212
43434343......4343......43434343
12............1212............12
43............4343............43
12121212......1212......12121212
43434343......4343......43434343
12............1212............12
43............4343............43
12121212..121212121212..12121212
43434343..434343434343..43434343
................................
................................
121212.....1212121212.....121212
434343.....4343434343.....434343
12.............12.............12
43.............43.............43
121212.........12.........121212
434343.........43.........434343
12.............12.............12
43.............43.............43
121212.........12.........121212
434343.........43.........434343
12.............12.............12
43.............43.............43
121212.....1212121212.....121212
434343.....4343434343.....434343
................................
................................
1212.........121212.........1212
4343.........434343.........4343
12.............12.............12
43.............43.............43
1212...........12...........1212
4343...........43...........4343
12.............12.............12
43.............43.............43
1212...........12...........1212
4343...........43...........4343
12.............12.............12
43.............43.............43
1212.........121212.........1212
4343.........434343.........4343
................................
................................
12.............12.............12
43.............43.............43
12.............12.............12
43.............43.............43
12.............12.............12
43.............43.............43
12.............12.............12
43.............43.............43
12.............12.............12
43.............43.............43
12.............12.............12
43.............43.............43
12.............12.............12
43.............43.............43
................................
................................
................................
................................
...............12...............
...............43...............
...............12...............
...............43...............
...............12...............
...............43...............
...............12...............
...............43...............
...............12...............
...............43...............
................................
................................
................................
`,
  },
  {
    id: "swirl",
    name: "Swirl",
    sourceFile: "swirl.layout",
    raw: String.raw`
kmahjongg-layout-v1.0
................................
12..12121212121212121212121212..
43..4343434343434343434343434312
12.12.........................43
43.43..12121212121212121212...12
12.12..4343434343434343434312.43
43.43.12...................43.12
12.12.43...................12.43
43.43.121212121212121212...43.12
12.12.434343434343434343...12.43
43.43......................43.12
12.12121212121212121212121212.43
43.43434343434343434343434343.12
12............................43
43121212121212121212121212121212
..434343434343434343434343434343
................................
12..............................
43..............................
12..............................
43..............................
12..............................
43..............................
12..............................
43......1212121212121212........
12......4343434343434343........
43..............................
12..............................
43..............................
12..............................
431212..........................
..4343..........................
................................
12..............................
43..............................
12..............................
43..............................
12..............................
43..............................
12..............................
43..........121212121212........
12..........434343434343........
43..............................
12..............................
43..............................
................................
................................
................................
................................
12..............................
43..............................
12..............................
43..............................
12..............................
43..............................
12..............................
43..............12121212........
................43434343........
................................
................................
................................
................................
................................
................................
................................
12..............................
43..............................
12..............................
43..............................
................................
................................
................................
....................1212........
....................4343........
................................
................................
................................
................................
................................
................................
`,
  },
  {
    id: "temple",
    name: "Temple",
    sourceFile: "temple.layout",
    raw: String.raw`
kmahjongg-layout-v1.0
121212.....1212121212.....121212
434343.....4343434343.....434343
1212.......1212121212.......1212
4343.....12434343434312.....4343
12.......43121212121243.......12
43...1212124343434343121212...43
.....4343431212121212434343.....
...12121212434343434312121212...
...43434343121212121243434343...
.....1212124343434343121212.....
12...4343431212121212434343...12
43.......12434343434312.......43
1212.....43121212121243.....1212
4343.......4343434343.......4343
121212.....1212121212.....121212
434343.....4343434343.....434343
12............................12
43............................43
.............121212.............
.............434343.............
...........1212121212...........
...........4343434343...........
.......121212121212121212.......
.......434343434343434343.......
.......121212121212121212.......
.......434343434343434343.......
...........1212121212...........
...........4343434343...........
.............121212.............
.............434343.............
12............................12
43............................43
................................
................................
................................
................................
..............1212..............
..............4343..............
..........121212121212..........
..........434343434343..........
..........121212121212..........
..........434343434343..........
..............1212..............
..............4343..............
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
...............12...............
...............43...............
...............12...............
...............43...............
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
`,
  },
  {
    id: "the-door",
    name: "The Door",
    sourceFile: "the_door.layout",
    raw: String.raw`
kmahjongg-layout-v1.0
.............121212.............
.............434343.............
.........12121212121212.........
.........43434343434343.........
.......1212..........1212.......
.......4343..........4343.......
.....121212..........121212.....
.....434343..........434343.....
.....121212..........121212.....
.....434343..........434343.....
...1212121212......1212121212...
...4343434343......4343434343...
.121212121212......121212121212.
.434343434343......434343434343.
.121212121212......121212121212.
.434343434343......434343434343.
................................
................................
.........12121212121212.........
.........43434343434343.........
.........12..........12.........
.........43..........43.........
.........12..........12.........
.........43..........43.........
.......1212..........1212.......
.......4343..........4343.......
.......1212..........1212.......
.......4343..........4343.......
.....121212..........121212.....
.....434343..........434343.....
...12121212..........12121212...
...43434343..........43434343...
................................
................................
.........12121212121212.........
.........43434343434343.........
.........12..........12.........
.........43..........43.........
.........12..........12.........
.........43..........43.........
.........12..........12.........
.........43..........43.........
.......1212..........1212.......
.......4343..........4343.......
.......1212..........1212.......
.......4343..........4343.......
.......1212..........1212.......
.......4343..........4343.......
................................
................................
.........12121212121212.........
.........43434343434343.........
.........12..........12.........
.........43..........43.........
.........12..........12.........
.........43..........43.........
.........12..........12.........
.........43..........43.........
.........12..........12.........
.........43..........43.........
.........12..........12.........
.........43..........43.........
.........12..........12.........
.........43..........43.........
................................
................................
.........12121212121212.........
.........43434343434343.........
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
`,
  },
  {
    id: "theatre",
    name: "Theatre",
    sourceFile: "theatre.layout",
    raw: String.raw`
kmahjongg-layout-v1.0
................................
..1212121212121212121212121212..
..4343434343434343434343434343..
..1212121212...12...1212121212..
..4343434343...43...4343434343..
..1212121212...12...1212121212..
..4343434343...43...4343434343..
..12...........12...........12..
..43...........43...........43..
..1212121212...12...1212121212..
..4343434343...43...4343434343..
..1212121212...12...1212121212..
..4343434343...43...4343434343..
..1212121212121212121212121212..
..4343434343434343434343434343..
................................
................................
..1212121212........1212121212..
..4343434343........4343434343..
..1212121212........1212121212..
..4343434343........4343434343..
..12121212............12121212..
..43434343............43434343..
................................
................................
..12121212............12121212..
..43434343............43434343..
..1212121212........1212121212..
..4343434343........4343434343..
..1212121212........1212121212..
..4343434343........4343434343..
................................
................................
................................
................................
....121212............121212....
....434343............434343....
........12............12........
........43............43........
................................
................................
........12............12........
........43............43........
....121212............121212....
....434343............434343....
................................
................................
................................
................................
................................
................................
....12....................12....
....43....................43....
................................
................................
................................
................................
................................
................................
....12....................12....
....43....................43....
................................
................................
................................
................................
................................
................................
..........................12....
..........................43....
................................
................................
................................
................................
................................
................................
....12....................12....
....43....................43....
................................
................................
................................
`,
  },
  {
    id: "time-tunnel",
    name: "Time Tunnel",
    sourceFile: "time_tunnel.layout",
    raw: String.raw`
kmahjongg-layout-v1.0
................................
................................
.....12121212121212121212.......
.....43434343434343434343.......
.....121212........121212.......
.....434343........434343.......
.....121212........121212.......
.....434343........434343.......
.....121212........121212.......
.....434343........434343.......
.....121212........121212.......
.....434343........434343.......
.....12121212121212121212.......
.....43434343434343434343.......
................................
................................
................................
................................
.......1212121212121212.........
.......4343434343434343.........
.......1212........1212.........
.......4343........4343.........
.......1212........1212.........
.......4343........4343.........
.......1212........1212.........
.......4343........4343.........
.......1212........1212.........
.......4343........4343.........
.......1212121212121212.........
.......4343434343434343.........
................................
................................
................................
................................
.........121212121212...........
.........434343434343...........
.......1212........1212.........
.......4343........4343.........
.......1212........1212.........
.......4343........4343.........
.......1212........1212.........
.......4343........4343.........
.......1212........1212.........
.......4343........4343.........
.........121212121212...........
.........434343434343...........
................................
................................
................................
................................
...........12121212.............
...........43434343.............
.........12........12...........
.......1243........4312.........
.......4312........1243.........
.......1243........4312.........
.......4312........1243.........
.......1243........4312.........
.......4312........1243.........
.........43........43...........
...........12121212.............
...........43434343.............
................................
................................
................................
................................
...........12121212.............
...........43434343.............
.........12........12...........
.........43........43...........
.........12........12...........
.......1243........4312.........
.......4312........1243.........
.........43........43...........
.........12........12...........
.........43........43...........
...........12121212.............
...........43434343.............
................................
................................
`,
  },
  {
    id: "tomb",
    name: "Tomb",
    sourceFile: "tomb.layout",
    raw: String.raw`
kmahjongg-layout-v1.0
................................
................................
......12121212121212121212......
......43434343434343434343......
......12121212121212121212......
......43434343434343434343......
......12121212121212121212......
......43434343434343434343......
......12121212121212121212......
......43434343434343434343......
......12121212121212121212......
......43434343434343434343......
............12121212............
............43434343............
..............1212..............
..............4343..............
................................
................................
......12121212121212121212......
......43434343434343434343......
......12121212121212121212......
......43434343434343434343......
........1212...12...1212........
........4343...43...4343........
......12121212....12121212......
......43434343....43434343......
......12121212....12121212......
......43434343....43434343......
............12....12............
............43....43............
................................
................................
................................
................................
......12................12......
......43................43......
........1212121212121212........
........4343434343434343........
........12............12........
........43............43........
........121212....121212........
........434343....434343........
......12....12....12....12......
......43....43....43....43......
................................
................................
................................
................................
................................
................................
......12................12......
......43................43......
...........1212121212...........
...........4343434343...........
........12............12........
........43............43........
............12....12............
............43....43............
......12....12....12....12......
......43....43....43....43......
................................
................................
................................
................................
................................
................................
......12................12......
......43................43......
............12121212............
............43434343............
................................
................................
............12....12............
............43....43............
................................
................................
................................
................................
................................
................................
`,
  },
  {
    id: "totem",
    name: "Totem",
    sourceFile: "totem.layout",
    raw: String.raw`
kmahjongg-layout-v1.0
12121212121212121212121212121212
43434343434343434343434343434343
..121212121212....121212121212..
..434343434343....434343434343..
....1212121212....1212121212....
....4343434343....4343434343....
............12121212............
............43434343............
............12121212............
............43434343............
............12121212............
............43434343............
............12121212............
............43434343............
............12121212............
............43434343............
........1212121212121212........
........4343434343434343........
....12......12....12......12....
....4312121243....4312121243....
......43434312....12434343......
............43....43............
............12....12............
............43....43............
............12....12............
............43....43............
............12....12............
............43....43............
............12....12............
............43....43............
............12....12............
............43....43............
..........121212121212..........
..........434343434343..........
............12....12............
............43....43............
............12....12............
............43....43............
............12....12............
............43....43............
................................
................................
................................
................................
................................
................................
................................
................................
............12121212............
............43434343............
............12....12............
............43....43............
............12....12............
............43....43............
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
............12121212............
............43434343............
............12....12............
............43....43............
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
`,
  },
  {
    id: "tower",
    name: "Tower",
    sourceFile: "tower.layout",
    raw: String.raw`
kmahjongg-layout-v1.0
# Level 0 -------------------------
....121212121212121212121212....
....434343434343434343434343....
....121212121212121212121212....
....434343434343434343434343....
....121212121212121212121212....
....434343434343434343434343....
....121212121212121212121212....
....434343434343434343434343....
....121212121212121212121212....
....434343434343434343434343....
....121212121212121212121212....
....434343434343434343434343....
....121212121212121212121212....
....434343434343434343434343....
....121212121212121212121212....
....434343434343434343434343....
# Level 1 -------------------------
................................
................................
......12121212121212121212......
......43434343434343434343......
......12121212121212121212......
......43434343434343434343......
......12121212121212121212......
......43434343434343434343......
......12121212121212121212......
......43434343434343434343......
......12121212121212121212......
......43434343434343434343......
......12121212121212121212......
......43434343434343434343......
................................
................................
# Level 2 -------------------------
................................
................................
......121212........121212......
......434343........434343......
......121212........121212......
......434343........434343......
................................
................................
................................
................................
......121212........121212......
......434343........434343......
......121212........121212......
......434343........434343......
................................
................................
# Level 3 -------------------------
................................
................................
......121212........121212......
......434343........434343......
......121212........121212......
......434343........434343......
................................
................................
................................
................................
......121212........121212......
......434343........434343......
......121212........121212......
......434343........434343......
................................
................................
# Level 4 -------------------------
................................
................................
......121212........121212......
......434343........434343......
......121212........121212......
......434343........434343......
................................
................................
................................
................................
......121212........121212......
......434343........434343......
......121212........121212......
......434343........434343......
................................
................................
`,
  },
  {
    id: "triangle",
    name: "Triangle",
    sourceFile: "triangle.layout",
    raw: String.raw`
kmahjongg-layout-v1.0
# Level 0 -------------------------
.121212121212121212121212121212.
.434343434343434343434343434343.
...12121212121212121212121212...
...43434343434343434343434343...
.....1212121212121212121212.....
.....4343434343434343434343.....
.......121212121212121212.......
.......434343434343434343.......
.........12121212121212.........
.........43434343434343.........
...........1212121212...........
...........4343434343...........
.............121212.............
.............434343.............
...............12...............
...............43...............
# Level 1 -------------------------
...12121212121212121212121212...
...43434343434343434343434343...
.....1212121212121212121212.....
.....4343434343434343434343.....
.......121212121212121212.......
.......434343434343434343.......
.........12121212121212.........
.........43434343434343.........
...........1212121212...........
...........4343434343...........
.............121212.............
.............434343.............
...............12...............
...............43...............
................................
................................
# Level 2 -------------------------
.....1212121212121212121212.....
.....4343434343434343434343.....
.......121212121212121212.......
.......434343434343434343.......
.........12121212121212.........
.........43434343434343.........
...........1212121212...........
...........4343434343...........
.............121212.............
.............434343.............
...............12...............
...............43...............
................................
................................
................................
................................
# Level 3 -------------------------
.......121212121212121212.......
.......434343434343434343.......
.........12121212121212.........
.........43434343434343.........
...........1212121212...........
...........4343434343...........
.............121212.............
.............434343.............
...............12...............
...............43...............
................................
................................
................................
................................
................................
................................
# Level 4 -------------------------
.........12121212121212.........
.........43434343434343.........
...........1212121212...........
...........4343434343...........
.............121212.............
.............434343.............
...............12...............
...............43...............
................................
................................
................................
................................
................................
................................
................................
................................
`,
  },
  {
    id: "up-and-down",
    name: "Up&Down",
    sourceFile: "up&down.layout",
    raw: String.raw`
kmahjongg-layout-v1.0
................................
....121212121212121212121212....
....434343434343434343434343....
....121212121212121212121212....
....434343434343434343434343....
....121212121212121212121212....
....434343434343434343434343....
....121212121212121212121212....
....434343434343434343434343....
....121212121212121212121212....
....434343434343434343434343....
....121212121212121212121212....
....434343434343434343434343....
....121212121212121212121212....
....434343434343434343434343....
................................
................................
....121212121212121212121212....
....434343434343434343434343....
....12..........121212121212....
....43..........434343434343....
....12........12121212121212....
....43........43434343434343....
....121212121212121212121212....
....434343434343434343434343....
....12121212121212........12....
....43434343434343........43....
....121212121212..........12....
....434343434343..........43....
....121212121212121212121212....
....434343434343434343434343....
................................
................................
....12....................12....
....43....................43....
................1212121212......
................4343434343......
..............121212121212......
..............434343434343......
......12121212121212121212......
......43434343434343434343......
......121212121212..............
......434343434343..............
......1212121212................
......4343434343................
....12....................12....
....43....................43....
................................
................................
................................
................................
................1212121212......
................4343434343......
..................12121212......
..................43434343......
......121212........121212......
......434343........434343......
......12121212..................
......43434343..................
......1212121212................
......4343434343................
................................
................................
................................
................................
................................
................................
....................121212......
....................434343......
......................1212......
......................4343......
......12................12......
......43................43......
......1212......................
......4343......................
......121212....................
......434343....................
................................
................................
................................
`,
  },
  {
    id: "vi",
    name: "Vi",
    sourceFile: "Vi.layout",
    raw: String.raw`
kmahjongg-layout-v1.0
12............................12
43............................43
1212........................1212
4343........................4343
121212....................121212
434343....................434343
12121212................12121212
43434343................43434343
1212121212............1212121212
4343434343............4343434343
121212121212........121212121212
434343434343........434343434343
12121212121212....12121212121212
43434343434343....43434343434343
12121212121212121212121212121212
43434343434343434343434343434343
................................
................................
................................
................................
12............................12
43............................43
1212........................1212
4343........................4343
121212....................121212
434343....................434343
12121212................12121212
43434343................43434343
1212121212............1212121212
4343434343............4343434343
121212121212........121212121212
434343434343........434343434343
................................
................................
................................
................................
................................
................................
12............................12
43............................43
12............................12
43............................43
1212........................1212
4343........................4343
121212....................121212
434343....................434343
12121212................12121212
43434343................43434343
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
12............................12
43............................43
1212........................1212
4343........................4343
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
................................
12............................12
43............................43
`,
  },
  {
    id: "well",
    name: "Well",
    sourceFile: "well.layout",
    raw: String.raw`
kmahjongg-layout-v1.0
............12121212............
............43434343............
..........121212121212..........
..........434343434343..........
......12121212121212121212......
....124343434343434343434312....
....431212121212121212121243....
....124343434343434343434312....
....431212121212121212121243....
....124343434343434343434312....
....431212121212121212121243....
......43434343434343434343......
............12121212............
............43434343............
............12121212............
............43434343............
................................
................................
................................
................................
........1212121212121212........
......12434343434343434312......
......431212........121243......
......124343........434312......
......431212........121243......
......124343........434312......
......43121212121212121243......
........4343434343434343........
............12....12............
............43....43............
................................
................................
................................
................................
................................
................................
..........121212121212..........
..........434343434343..........
..........12........12..........
..........43........43..........
..........12........12..........
..........43........43..........
..........121212121212..........
..........434343434343..........
................................
................................
................................
................................
................................
................................
................................
................................
..........121212121212..........
..........434343434343..........
..........12........12..........
..........43........43..........
..........12........12..........
..........43........43..........
..........121212121212..........
..........434343434343..........
................................
................................
................................
................................
................................
................................
................................
................................
..........121212121212..........
..........434343434343..........
..........12........12..........
..........43........43..........
..........12........12..........
..........43........43..........
..........121212121212..........
..........434343434343..........
................................
................................
................................
................................
`,
  },
  {
    id: "x-shaped",
    name: "X-shaped",
    sourceFile: "X_shaped.layout",
    raw: String.raw`
kmahjongg-layout-v1.0
..121212121212....121212121212..
..434343434343....434343434343..
........121212....121212........
........434343....434343........
..........1212....1212..........
..........4343....4343..........
............12121212............
............43434343............
..............1212..............
..............4343..............
............12121212............
............43434343............
........121212....121212........
........434343....434343........
..121212121212....121212121212..
..434343434343....434343434343..
...1212121212......1212121212...
...4343434343......4343434343...
.........1212......1212.........
.........4343......4343.........
..........1212....12............
..........4343....43............
.............121212.............
.............434343.............
..............1212..............
..............4343..............
............12121212............
............43434343............
..........1212....1212..........
..........4343....4343..........
...1212121212......1212121212...
...4343434343......4343434343...
.....12121212......12121212.....
.....43434343......43434343.....
.........12..........12.........
.........43..........43.........
............12....12............
............43....43............
..............1212..............
..............4343..............
...............12...............
...............43...............
.............12..12.............
.............43..43.............
............12....12............
............43....43............
.....12121212......12121212.....
.....43434343......43434343.....
.......1212..........1212.......
.......4343..........4343.......
................................
................................
................................
................................
...............12...............
...............43...............
...............12...............
...............43...............
................................
................................
................................
................................
.......121212......121212.......
.......434343......434343.......
........12............12........
........43............43........
................................
................................
................................
................................
................................
...............12...............
...............43...............
................................
................................
................................
................................
................................
..........12........12..........
..........43........43..........
`,
  }
];
